var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _polygon;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSkillImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-15"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 68.73,
    y: 116.42,
    width: 125.22,
    height: 83.84,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194,200.26s0-.53,0-1.53,0-2.49,0-4.42c0-3.88,0-9.57,0-16.86,0-14.57-.05-35.51-.09-61l.18.18-125.21,0h0l.23-.22c0,29.87,0,58.27,0,83.84l-.21-.21,90.21.1,25.78.06,6.85,0h1.77l.61,0h-2.33l-6.82,0-25.72.05-90.35.1h-.2v-.2c0-25.57,0-54,0-83.84v-.23h.23l125.21,0h.18v.18c0,25.57-.07,46.55-.1,61.14,0,7.27,0,12.95,0,16.82,0,1.92,0,3.39,0,4.39S194,200.26,194,200.26Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.73,123.9c0-.12,28-.23,62.56-.23s62.56.11,62.56.23-28,.22-62.56.22S68.73,124,68.73,123.9Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.67,120.12a1,1,0,1,1-1-1A1,1,0,0,1,73.67,120.12Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 76.11,
    cy: 120.12,
    r: 1,
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.5,120.12a1,1,0,1,1-1-1A1,1,0,0,1,80.5,120.12Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 79.5,
    y: 132.64,
    width: 33.4,
    height: 33.4,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.78,142.08c0,.13-13,.23-29.09.23s-29.1-.1-29.1-.23,13-.22,29.1-.22S176.78,142,176.78,142.08Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.78,148.29c0,.12-13,.22-29.09.22s-29.1-.1-29.1-.22,13-.22,29.1-.22S176.78,148.17,176.78,148.29Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.78,154.5c0,.12-13,.22-29.09.22s-29.1-.1-29.1-.22,13-.23,29.1-.23S176.78,154.37,176.78,154.5Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153,160.7a6.93,6.93,0,0,1-1.35.09l-3.69.07c-3.11,0-7.41.07-12.15.07s-9,0-12.16-.07l-3.69-.07a6.93,6.93,0,0,1-1.35-.09,7.64,7.64,0,0,1,1.35-.08l3.69-.07c3.11-.05,7.41-.07,12.16-.07s9,0,12.15.07l3.69.07A7.64,7.64,0,0,1,153,160.7Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.59,
    y: 177.3,
    width: 15.7,
    height: 15.7,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.06,
    y: 177.3,
    width: 15.7,
    height: 15.7,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138.52,
    y: 177.3,
    width: 15.7,
    height: 15.7,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166.99,
    y: 177.3,
    width: 15.7,
    height: 15.7,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.09,143.67a15,15,0,0,1-2.66,2.79l.69,3.51-5.41,2.4-2.14-2.87a14.57,14.57,0,0,1-3.85.1l-2,3-5.53-2.13.52-3.54a14.09,14.09,0,0,1-2.79-2.66l-3.51.69-2.4-5.41,2.87-2.13a14.23,14.23,0,0,1-.1-3.86l-3-2L401,126l3.54.51a14.37,14.37,0,0,1,2.66-2.79l-.7-3.51,5.41-2.4L414,120.7a14.64,14.64,0,0,1,3.86-.1l2-3,5.52,2.13-.52,3.54a14.44,14.44,0,0,1,2.8,2.66l3.51-.69,2.4,5.41-2.87,2.13a14.23,14.23,0,0,1,.09,3.86l3,2-2.12,5.52-3.54-.51Zm-6-6a6.34,6.34,0,1,0-8.2,3.65A6.33,6.33,0,0,0,422.11,137.63Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.11,137.63a4.77,4.77,0,0,1-.68,1.42,6.43,6.43,0,0,1-6.42,2.69,6.42,6.42,0,0,1-3.09-1.48,6,6,0,0,1-1.23-1.41,6.14,6.14,0,0,1-.79-1.79,6.52,6.52,0,0,1,.2-4.06,6.6,6.6,0,0,1,2.57-3.14,6.2,6.2,0,0,1,1.79-.79,6.28,6.28,0,0,1,1.86-.23A6.46,6.46,0,0,1,421.7,132a6.31,6.31,0,0,1,.86,4.17,4.6,4.6,0,0,1-.45,1.5s.19-.53.31-1.52a6.37,6.37,0,0,0-.94-4,6.17,6.17,0,0,0-5.17-2.91,5.94,5.94,0,0,0-1.76.22,6.18,6.18,0,0,0-4.31,7.57,5.85,5.85,0,0,0,.75,1.69,5.79,5.79,0,0,0,1.15,1.35,6.23,6.23,0,0,0,5.78,1.31,6.34,6.34,0,0,0,3.39-2.35A12.15,12.15,0,0,0,422.11,137.63Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.09,143.67l.22,0,.67.08,2.65.36-.06,0c.54-1.41,1.24-3.28,2.1-5.53l0,.11-3-2-.06,0v-.06a14.62,14.62,0,0,0-.11-3.83v-.07l.06,0,2.86-2.15,0,.16-2.41-5.4.15.08-3.5.7-.09,0-.06-.08a14.21,14.21,0,0,0-2.77-2.62l-.08-.06,0-.09c.16-1.1.33-2.31.51-3.54l.1.17-5.52-2.12.2-.06-2,3-.06.09-.1,0a14.86,14.86,0,0,0-3.81.1l-.11,0-.06-.09-2.14-2.86.22,0-5.41,2.41.1-.2c.22,1.1.46,2.3.69,3.5l0,.11-.09.07a14.42,14.42,0,0,0-2.63,2.76h0l-.17.07h-.11l-.11,0-.22,0-.45-.07-.89-.13-1.76-.25.2-.12L399,131.6l-.07-.21,3,2,.09.06v.11a14.27,14.27,0,0,0,.09,3.81l0,.11-.09.06-2.87,2.13.06-.21q1.21,2.78,2.39,5.42l-.19-.1,3.51-.69.1,0,.06.08a14.27,14.27,0,0,0,2.76,2.63l.08.06v.1c-.18,1.21-.36,2.38-.53,3.53l-.09-.16,5.52,2.14-.17.05,2-3,0-.07h.08a14.2,14.2,0,0,0,3.82-.09h.08l0,.06,2.13,2.88-.13,0,5.42-2.37,0,.09c-.27-1.41-.49-2.56-.67-3.52v0l0,0a14.68,14.68,0,0,0,2.09-2l.46-.55.15-.18-.13.2c-.09.13-.23.32-.44.57a13.69,13.69,0,0,1-2,2.07l0-.06c.19,1,.43,2.1.71,3.5V150l-.06,0-5.4,2.43-.07,0-.06-.07-2.14-2.86.11.05a14.68,14.68,0,0,1-3.89.11l.13-.06-2,3-.06.09-.1,0-5.53-2.12-.11,0v-.12q.26-1.72.51-3.54l.07.15a14.67,14.67,0,0,1-2.83-2.69l.16.06-3.51.7-.13,0-.06-.12-2.4-5.4-.06-.13.11-.08,2.87-2.14-.07.16a14.94,14.94,0,0,1-.1-3.9l.08.17-3-2-.12-.08,0-.14,2.13-5.52.05-.13.14,0,1.77.25.88.13.45.07.22,0,.11,0h.11c-.35.15-.09,0-.17.08h0A14.77,14.77,0,0,1,407,123.6l-.06.18c-.24-1.21-.48-2.41-.69-3.51l0-.15.13-.06,5.41-2.39.13-.06.09.11c.73,1,1.46,2,2.13,2.87l-.17-.06a14.76,14.76,0,0,1,3.91-.1l-.17.08,2-3,.07-.11.13,0,5.52,2.14.12,0,0,.12c-.18,1.24-.36,2.45-.52,3.54l-.06-.15a14.49,14.49,0,0,1,2.81,2.7l-.14-.06,3.51-.68.11,0,.05.11c.84,1.9,1.63,3.71,2.39,5.41l0,.1-.09.06-2.87,2.13.05-.12a14.6,14.6,0,0,1,.08,3.89l-.05-.1,3,2,.06,0,0,.06-2.16,5.51,0,.05h0l-2.62-.41-.68-.12Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.56,126.83a11.88,11.88,0,0,1-2.21,2.32l.57,2.91-4.48,2-1.78-2.38a11.79,11.79,0,0,1-3.2.08l-1.65,2.47-4.58-1.77.43-2.93a11.88,11.88,0,0,1-2.32-2.21l-2.91.57-2-4.48,2.38-1.78a11.79,11.79,0,0,1-.08-3.2l-2.47-1.65,1.77-4.58,2.93.43a11.88,11.88,0,0,1,2.21-2.32l-.57-2.91,4.48-2,1.78,2.38a11.79,11.79,0,0,1,3.2-.08l1.65-2.47L457.3,107l-.43,2.93a12.18,12.18,0,0,1,2.32,2.21l2.91-.57,2,4.49-2.38,1.77a11.79,11.79,0,0,1,.08,3.2l2.47,1.65-1.77,4.58-2.93-.43Zm-5-5a5.27,5.27,0,1,0-6.81,3A5.27,5.27,0,0,0,454.6,121.83Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.22,99.48a19,19,0,0,1-3.46,3.64l.9,4.56-7,3.12-2.78-3.73a19.14,19.14,0,0,1-5,.13l-2.59,3.86-7.18-2.77.67-4.6a19,19,0,0,1-3.64-3.46l-4.56.9-3.12-7,3.73-2.78a19.14,19.14,0,0,1-.13-5l-3.86-2.59,2.77-7.18,4.6.67A18.94,18.94,0,0,1,413,73.56l-.9-4.57,7-3.12,2.78,3.73a19.14,19.14,0,0,1,5-.13l2.59-3.86,7.18,2.77L436,73a18.94,18.94,0,0,1,3.63,3.46l4.57-.9,3.12,7-3.73,2.78a19.14,19.14,0,0,1,.13,5L447.59,93l-2.77,7.18-4.6-.67Zm-7.78-7.85a8.26,8.26,0,1,0-10.67,4.74A8.25,8.25,0,0,0,432.44,91.63Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.62,61.36a4.05,4.05,0,0,1,.53-.59l1.52-1.53c1.29-1.28,3.09-3,5.1-4.94l.05,0v.25c-2-1.87-3.84-3.59-5.14-4.84l-1.53-1.49a4.05,4.05,0,0,1-.53-.59,3.16,3.16,0,0,1,.62.49l1.61,1.41c1.34,1.2,3.19,2.89,5.21,4.77l.14.12-.14.13-.05.05c-2,1.91-3.83,3.63-5.17,4.86l-1.6,1.45A3.16,3.16,0,0,1,369.62,61.36Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354,47.59a3.64,3.64,0,0,1-.53.6L352,49.71c-1.29,1.28-3.09,3-5.1,4.94l-.05.05v-.26c2,1.88,3.84,3.59,5.14,4.84l1.53,1.5a4.41,4.41,0,0,1,.53.58,2.82,2.82,0,0,1-.62-.48c-.44-.38-1-.86-1.61-1.41-1.34-1.21-3.18-2.89-5.21-4.77l-.13-.13.13-.13.05,0c2-1.92,3.83-3.64,5.17-4.87l1.6-1.44A3,3,0,0,1,354,47.59Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358,64.6c-.09,0,1.55-4.64,3.66-10.28s3.9-10.2,4-10.16S364.12,48.8,362,54.44,358.11,64.64,358,64.6Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.36,74.46s0-.27,0-.77,0-1.26,0-2.22c0-1.94,0-4.78,0-8.39,0-7.22,0-17.54-.08-30l.15.15-50.76,0h0l.18-.18c0,14.95,0,29.08,0,41.37l-.16-.16,36.66.08,10.39,0,2.76,0h-2.69l-10.36.05-36.76.08h-.16v-.16c0-12.29,0-26.42,0-41.37v-.18h.18l50.76,0h.15v.15c0,12.48-.06,22.84-.08,30.08,0,3.6,0,6.42,0,8.36,0,1,0,1.68,0,2.19S387.36,74.46,387.36,74.46Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.76,39.23c0,.1-11.46.18-25.59.18s-25.6-.08-25.6-.18,11.46-.18,25.6-.18S387.76,39.13,387.76,39.23Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.74,36.21a.69.69,0,0,1-.69.69.69.69,0,0,1,0-1.38A.69.69,0,0,1,340.74,36.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 342.54,
    cy: 36.21,
    r: 0.68,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.72,36.21a.69.69,0,1,1-.69-.69A.69.69,0,0,1,345.72,36.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.84,
    y: 53.04,
    width: 117.38,
    height: 47.68,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.22,100.72s0-.29,0-.85,0-1.39,0-2.47c0-2.18,0-5.37,0-9.49,0-8.23,0-20.13-.07-34.87l.13.13-117.37.06h0L172,53v47.68l-.18-.18,84.16.09,24.41.05,6.54,0h0l-6.5,0-24.37,0-84.28.08h-.18v-.18c0-14.86,0-31,0-47.68v-.18h.2l117.37,0h.13V53c0,14.77-.05,26.7-.07,34.95,0,4.1,0,7.29,0,9.46,0,1.07,0,1.89,0,2.45S289.22,100.72,289.22,100.72Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172,59.47c0-.1,26.24-.18,58.6-.18s58.6.08,58.6.18-26.23.19-58.6.19S172,59.58,172,59.47Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M176.87,56.6a.85.85,0,0,1-.85.85.85.85,0,1,1,0-1.7A.85.85,0,0,1,176.87,56.6Z",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M179.79,56.6a.85.85,0,0,1-.85.85.85.85,0,1,1,0-1.7A.85.85,0,0,1,179.79,56.6Z",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 181.81,
    cy: 56.6,
    r: 0.85,
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 181.81,
    y: 67.22,
    width: 28.35,
    height: 28.35,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.1,74.82c0,.1-14.59.19-32.58.19s-32.59-.09-32.59-.19,14.59-.19,32.59-.19S281.1,74.72,281.1,74.82Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.1,80.6c0,.1-14.59.18-32.58.18s-32.59-.08-32.59-.18,14.59-.19,32.59-.19S281.1,80.49,281.1,80.6Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.88,86.37a1.3,1.3,0,0,1-.42,0l-1.23,0-4.49.06-14.83.06-14.84-.06-4.49-.06-1.23,0a1.3,1.3,0,0,1-.42,0,2.37,2.37,0,0,1,.42,0l1.23,0,4.49-.06,14.84,0,14.83,0,4.49.06,1.23,0A2.37,2.37,0,0,1,257.88,86.37Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M472.86,445.09c0,.14-99.78.26-222.85.26s-222.87-.12-222.87-.26,99.76-.26,222.87-.26S472.86,444.94,472.86,445.09Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Screens--inject-15"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 295.03,
    y: 135.41,
    width: 140.13,
    height: 114.16,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285.07,
    y: 142.66,
    width: 140.13,
    height: 114.16,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 271.34,
    y: 150.61,
    width: 143.87,
    height: 117.21,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.21,267.82s0-.75,0-2.16,0-3.53,0-6.26c0-5.48,0-13.51-.05-23.75,0-20.46-.07-49.73-.12-85l.22.22-143.85,0h0l.26-.26c0,42.38,0,82.4,0,117.21l-.24-.24,104,.12,29.42.06,7.79,0h2l.69,0h-2.64l-7.75,0-29.37.06-104.11.12h-.23v-.23c0-34.81,0-74.83,0-117.21v-.26h.28l143.85,0h.22v.22c-.05,35.36-.09,64.68-.11,85.18,0,10.21-.05,18.23-.06,23.7,0,2.71,0,4.8,0,6.21S415.21,267.82,415.21,267.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.88,167.55l-1.55.56,1.55.57v.58l-2.21-.84v-.61l2.21-.84Z",
    style: {
      fill: "#1A1C20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.52,166.49v3.25h-.75v-1.33h-1.48v1.33h-.75v-3.25h.75v1.28h1.48v-1.28Z",
    style: {
      fill: "#1A1C20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294,167.1h-1v-.61h2.83v.61h-1v2.64H294Z",
    style: {
      fill: "#1A1C20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.11,169.74v-2l-1,1.6h-.34l-.95-1.56v1.91h-.71v-3.25h.62l1.22,2,1.2-2h.61v3.25Z",
    style: {
      fill: "#1A1C20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.58,166.49h.75v2.64H303v.61h-2.38Z",
    style: {
      fill: "#1A1C20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.48,167.81v.61l-2.2.84v-.58l1.54-.57-1.54-.56V167Z",
    style: {
      fill: "#1A1C20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.57,256.43,286,257l1.55.56v.58l-2.21-.84v-.61l2.21-.84Z",
    style: {
      fill: "#1A1C20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.22,254.71h.65l-1.53,4.37h-.65Z",
    style: {
      fill: "#1A1C20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293,255.37v3.25h-.76v-1.33H290.8v1.33h-.75v-3.25h.75v1.28h1.47v-1.28Z",
    style: {
      fill: "#1A1C20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.46,256h-1v-.61h2.82V256h-1v2.64h-.76Z",
    style: {
      fill: "#1A1C20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.61,258.62v-1.95l-1,1.61h-.34l-.95-1.57v1.91h-.7v-3.25h.62l1.21,2,1.2-2h.62v3.25Z",
    style: {
      fill: "#1A1C20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.08,255.37h.75V258h1.63v.61h-2.38Z",
    style: {
      fill: "#1A1C20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306,256.69v.61l-2.21.84v-.58l1.55-.56-1.55-.57v-.58Z",
    style: {
      fill: "#1A1C20"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M299.07,176.44l-1.65.63,1.65.64v.38l-2.08-.82v-.4l2.08-.82Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M302.65,175.45v3.25h-.46v-1.45h-1.86v1.45h-.47v-3.25h.47v1.4h1.86v-1.4Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M306,178.29v.41h-2.36v-3.25h2.3v.4h-1.83v1h1.63v.39h-1.63v1Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M308.8,177.88h-1.73l-.35.82h-.48l1.47-3.25h.46l1.47,3.25h-.49Zm-.16-.37-.7-1.59-.71,1.59Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M310.12,175.45h1.37a1.63,1.63,0,1,1,0,3.25h-1.37Zm1.34,2.84a1.22,1.22,0,1,0,0-2.44h-.88v2.44Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M315.85,176.87v.4l-2.08.82v-.38l1.65-.64-1.65-.63v-.39Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M299.07,187.56l-1.65.63,1.65.64v.38l-2.08-.82V188l2.08-.82Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M300.51,187h-1.12v-.4h2.69v.4H301v2.85h-.46Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M302.58,186.57h.47v3.25h-.47Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M304.66,187h-1.11v-.4h2.68v.4h-1.11v2.85h-.46Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M306.74,186.57h.46v2.84H309v.41h-2.22Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M311.85,189.41v.41h-2.36v-3.25h2.29v.4H310v1h1.63v.4H310v1Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M314.5,188v.4l-2.08.82v-.38l1.65-.64-1.65-.63v-.39Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M316.54,186.57H317v2.84h1.76v.41h-2.22Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M319,188.59a1.28,1.28,0,1,1,1.28,1.26A1.22,1.22,0,0,1,319,188.59Zm2.1,0a.83.83,0,1,0-1.65,0,.83.83,0,1,0,1.65,0Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M323.46,187.34v.43h-.1a.74.74,0,0,0-.78.83v1.23h-.44v-2.46h.42v.41A.94.94,0,0,1,323.46,187.34Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M326.19,188.74h-2a.83.83,0,0,0,.89.72.91.91,0,0,0,.71-.3l.24.29a1.34,1.34,0,0,1-2.29-.86,1.21,1.21,0,0,1,1.24-1.25,1.18,1.18,0,0,1,1.21,1.26A.66.66,0,0,1,326.19,188.74Zm-2-.32h1.58a.79.79,0,0,0-1.58,0Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M330.9,188.4v1.42h-.45v-1.37c0-.48-.23-.71-.63-.71a.71.71,0,0,0-.74.81v1.27h-.45v-1.37c0-.48-.23-.71-.63-.71a.71.71,0,0,0-.74.81v1.27h-.44v-2.46h.42v.37a1,1,0,0,1,.85-.39.91.91,0,0,1,.86.45,1.08,1.08,0,0,1,.94-.45A.94.94,0,0,1,330.9,188.4Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M332.88,186.6a.29.29,0,0,1,.3-.29.28.28,0,0,1,.3.28.29.29,0,0,1-.3.3A.29.29,0,0,1,332.88,186.6Zm.08.76h.45v2.46H333Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M336.8,188.59a1.2,1.2,0,0,1-1.24,1.26,1.06,1.06,0,0,1-.86-.4v1.27h-.45v-3.36h.43v.39a1.06,1.06,0,0,1,.88-.41A1.19,1.19,0,0,1,336.8,188.59Zm-.45,0a.83.83,0,1,0-1.66,0,.83.83,0,1,0,1.66,0Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M337.1,189.56l.19-.35a1.65,1.65,0,0,0,.86.25c.41,0,.59-.12.59-.33,0-.56-1.56-.08-1.56-1.06,0-.44.4-.73,1-.73a1.75,1.75,0,0,1,.89.22l-.19.35a1.31,1.31,0,0,0-.71-.19c-.39,0-.58.14-.58.34,0,.57,1.56.1,1.56,1.06,0,.44-.41.73-1.06.73A1.82,1.82,0,0,1,337.1,189.56Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M342,187.36v2.46h-.42v-.37a1,1,0,0,1-.84.4,1,1,0,0,1-1.06-1.08v-1.41h.45v1.36c0,.49.24.73.66.73a.72.72,0,0,0,.76-.82v-1.27Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M347,188.4v1.42h-.44v-1.37c0-.48-.23-.71-.64-.71a.71.71,0,0,0-.73.81v1.27h-.45v-1.37c0-.48-.23-.71-.63-.71a.71.71,0,0,0-.74.81v1.27h-.45v-2.46h.43v.37a1,1,0,0,1,.85-.39.9.9,0,0,1,.85.45,1.11,1.11,0,0,1,.95-.45A.93.93,0,0,1,347,188.4Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M351,187.56l-1.64.63,1.64.64v.38l-2.07-.82V188l2.07-.82Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M352.69,185.91h.41l-1.53,4.37h-.41Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M354.19,187h-1.11v-.4h2.69v.4h-1.12v2.85h-.46Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M356.27,186.57h.46v3.25h-.46Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M358.35,187h-1.11v-.4h2.68v.4h-1.11v2.85h-.46Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M360.43,186.57h.46v2.84h1.76v.41h-2.22Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M365.54,189.41v.41h-2.36v-3.25h2.29v.4h-1.83v1h1.63v.4h-1.63v1Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M368.19,188v.4l-2.08.82v-.38l1.65-.64-1.65-.63v-.39Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M299.07,198.68l-1.65.64,1.65.63v.39l-2.08-.83v-.39l2.08-.83Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M300.78,197h.4l-1.53,4.37h-.41Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M304.28,197.69v3.25h-.46v-1.45H302v1.45h-.47v-3.25H302v1.4h1.86v-1.4Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M307.61,200.53v.41h-2.35v-3.25h2.29v.41h-1.83v1h1.63v.4h-1.63v1Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M310.43,200.13H308.7l-.35.81h-.48l1.47-3.25h.46l1.47,3.25h-.48Zm-.16-.37-.7-1.6-.7,1.6Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M311.75,197.69h1.37a1.63,1.63,0,1,1,0,3.25h-1.37Zm1.34,2.84a1.22,1.22,0,1,0,0-2.43h-.87v2.43Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M317.48,199.12v.39l-2.08.83V200l1.65-.63-1.65-.64v-.39Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M290.45,208.33l-1.64.64,1.64.63V210l-2.08-.82v-.4l2.08-.82Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M294,209.71c0,.56-.42.88-1.24.88h-1.55v-3.25h1.45c.75,0,1.17.32,1.17.84a.83.83,0,0,0,.17,1.53Zm-2.33-2v1h1c.48,0,.74-.18.74-.52s-.26-.52-.74-.52Zm1.86,2c0-.38-.28-.55-.79-.55h-1.07v1.08h1.07C293.29,210.21,293.57,210.05,293.57,209.68Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M294.49,209a1.73,1.73,0,1,1,1.73,1.66A1.65,1.65,0,0,1,294.49,209Zm3,0a1.27,1.27,0,1,0-1.26,1.24A1.22,1.22,0,0,0,297.48,209Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M298.65,207.34H300a1.63,1.63,0,1,1,0,3.25h-1.37Zm1.34,2.85a1.22,1.22,0,1,0,0-2.44h-.88v2.44Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M303.58,209.47v1.12h-.46v-1.13l-1.29-2.12h.5l1,1.72,1-1.72h.46Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M307.24,208.77v.4l-2.08.82v-.39l1.65-.63-1.65-.64V208Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M290.45,219.45l-1.64.64,1.64.63v.39l-2.08-.82v-.4l2.08-.82Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M294,218.47v3.24h-.46v-1.44h-1.87v1.44h-.46v-3.24h.46v1.39h1.87v-1.39Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M295.75,218.47v3.24h-.46v-2.84h-.73v-.4Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M298.63,219.89v.4l-2.08.82v-.39l1.65-.63-1.65-.64v-.38Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M300.71,218.47h.34v2.95h1.82v.29h-2.16Z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M303.09,220.49a1.24,1.24,0,1,1,1.24,1.25A1.2,1.2,0,0,1,303.09,220.49Zm2.14,0a.91.91,0,1,0-.9.95A.89.89,0,0,0,305.23,220.49Z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M307.47,219.25v.32h-.08a.79.79,0,0,0-.82.9v1.24h-.33v-2.44h.31v.48A1,1,0,0,1,307.47,219.25Z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M310.16,220.59h-2a.91.91,0,0,0,1,.85,1,1,0,0,0,.75-.32l.18.22a1.19,1.19,0,0,1-.94.4,1.21,1.21,0,0,1-1.28-1.25,1.18,1.18,0,0,1,1.19-1.24,1.16,1.16,0,0,1,1.18,1.24Zm-2-.24h1.73a.87.87,0,0,0-1.73,0Z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M314.86,220.3v1.41h-.33v-1.38c0-.51-.26-.78-.7-.78a.78.78,0,0,0-.81.88v1.28h-.33v-1.38c0-.51-.26-.78-.71-.78a.79.79,0,0,0-.82.88v1.28h-.33v-2.44h.32v.45a1,1,0,0,1,.9-.47.88.88,0,0,1,.86.52,1.07,1.07,0,0,1,1-.52A.93.93,0,0,1,314.86,220.3Z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M316.89,218.5a.24.24,0,0,1,.24-.23.23.23,0,0,1,.24.23.24.24,0,0,1-.24.24A.24.24,0,0,1,316.89,218.5Zm.07.77h.33v2.44H317Z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M320.68,220.49a1.19,1.19,0,0,1-1.21,1.25,1.06,1.06,0,0,1-.93-.49v1.36h-.33v-3.34h.32v.48a1.07,1.07,0,0,1,.94-.5A1.18,1.18,0,0,1,320.68,220.49Zm-.32,0a.91.91,0,1,0-1.82,0,.91.91,0,1,0,1.82,0Z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M321,221.43l.15-.26a1.46,1.46,0,0,0,.87.28c.46,0,.65-.16.65-.4,0-.64-1.58-.14-1.58-1.1,0-.4.35-.7,1-.7a1.64,1.64,0,0,1,.86.23l-.14.27a1.26,1.26,0,0,0-.72-.21c-.44,0-.64.17-.64.4,0,.66,1.58.16,1.58,1.1,0,.42-.37.7-1,.7A1.59,1.59,0,0,1,321,221.43Z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M325.82,219.27v2.44h-.32v-.44a1,1,0,0,1-.87.47.94.94,0,0,1-1-1.05v-1.42h.33v1.38c0,.52.26.79.73.79a.79.79,0,0,0,.83-.89v-1.28Z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M330.76,220.3v1.41h-.32v-1.38c0-.51-.26-.78-.71-.78a.78.78,0,0,0-.81.88v1.28h-.33v-1.38c0-.51-.26-.78-.71-.78a.79.79,0,0,0-.81.88v1.28h-.33v-2.44h.31v.45a1,1,0,0,1,.9-.47.89.89,0,0,1,.87.52,1,1,0,0,1,1-.52A.93.93,0,0,1,330.76,220.3Z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M335.09,218.27v3.44h-.31v-.48a1.06,1.06,0,0,1-.94.51,1.25,1.25,0,0,1,0-2.49,1.07,1.07,0,0,1,.93.49v-1.47Zm-.32,2.22a.91.91,0,1,0-.9.95A.89.89,0,0,0,334.77,220.49Z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M335.76,220.49a1.25,1.25,0,1,1,1.25,1.25A1.21,1.21,0,0,1,335.76,220.49Zm2.15,0a.91.91,0,1,0-.9.95A.89.89,0,0,0,337.91,220.49Z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M338.92,218.27h.32v3.44h-.32Z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M339.92,220.49a1.24,1.24,0,1,1,1.24,1.25A1.2,1.2,0,0,1,339.92,220.49Zm2.14,0a.91.91,0,1,0-.9.95A.89.89,0,0,0,342.06,220.49Z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M344.3,219.25v.32h-.08a.79.79,0,0,0-.82.9v1.24h-.33v-2.44h.31v.48A1,1,0,0,1,344.3,219.25Z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M345.8,221.43l.15-.26a1.41,1.41,0,0,0,.87.28c.46,0,.65-.16.65-.4,0-.64-1.58-.14-1.58-1.1,0-.4.34-.7,1-.7a1.68,1.68,0,0,1,.87.23l-.15.27a1.24,1.24,0,0,0-.72-.21c-.44,0-.63.17-.63.4,0,.66,1.58.16,1.58,1.1,0,.42-.37.7-1,.7A1.58,1.58,0,0,1,345.8,221.43Z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M348.33,218.5a.24.24,0,0,1,.24-.23.23.23,0,0,1,.24.23.24.24,0,0,1-.24.24A.24.24,0,0,1,348.33,218.5Zm.08.77h.32v2.44h-.32Z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M350.94,221.56a.78.78,0,0,1-.52.18.64.64,0,0,1-.71-.71v-1.48h-.44v-.28h.44v-.53H350v.53h.74v.28H350V221a.39.39,0,0,0,.42.44.56.56,0,0,0,.36-.12Z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M354.59,220.2v1.51h-.32v-.38a.9.9,0,0,1-.84.41c-.55,0-.89-.29-.89-.71s.24-.7.94-.7h.78v-.14a.6.6,0,0,0-.69-.65,1.21,1.21,0,0,0-.81.29l-.15-.25a1.53,1.53,0,0,1,1-.33A.87.87,0,0,1,354.59,220.2Zm-.33.78v-.4h-.77c-.47,0-.62.19-.62.44s.23.46.61.46A.78.78,0,0,0,354.26,221Z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M359.51,220.3v1.41h-.33v-1.38c0-.51-.26-.78-.7-.78a.79.79,0,0,0-.82.88v1.28h-.33v-1.38c0-.51-.26-.78-.7-.78a.79.79,0,0,0-.82.88v1.28h-.33v-2.44h.32v.45a1,1,0,0,1,.89-.47.88.88,0,0,1,.87.52,1.05,1.05,0,0,1,1-.52A.93.93,0,0,1,359.51,220.3Z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M362.53,220.59h-2a.91.91,0,0,0,1,.85,1,1,0,0,0,.75-.32l.18.22a1.19,1.19,0,0,1-.94.4,1.21,1.21,0,0,1-1.28-1.25,1.19,1.19,0,1,1,2.38,0S362.53,220.56,362.53,220.59Zm-2-.24h1.73a.87.87,0,0,0-1.73,0Z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M364.49,221.56a.76.76,0,0,1-.51.18.65.65,0,0,1-.72-.71v-1.48h-.43v-.28h.43v-.53h.33v.53h.74v.28h-.74V221a.39.39,0,0,0,.42.44.54.54,0,0,0,.36-.12Z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M365.42,221.48a.71.71,0,0,1-.07.27l-.19.64h-.23l.16-.67a.24.24,0,0,1-.17-.24.25.25,0,0,1,.25-.25A.24.24,0,0,1,365.42,221.48Z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M367.08,220.49a1.2,1.2,0,0,1,1.26-1.24,1.09,1.09,0,0,1,1,.49l-.25.16a.83.83,0,0,0-.71-.36,1,1,0,0,0,0,1.9.82.82,0,0,0,.71-.35l.25.16a1.09,1.09,0,0,1-1,.49A1.21,1.21,0,0,1,367.08,220.49Z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M369.65,220.49a1.24,1.24,0,1,1,1.25,1.25A1.21,1.21,0,0,1,369.65,220.49Zm2.15,0a.89.89,0,0,0-.9-1,1,1,0,0,0,0,1.9A.89.89,0,0,0,371.8,220.49Z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M375.05,220.3v1.41h-.33v-1.38a.68.68,0,0,0-.73-.78.8.8,0,0,0-.86.88v1.28h-.33v-2.44h.32v.45a1,1,0,0,1,.93-.47A.94.94,0,0,1,375.05,220.3Z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M375.6,221.43l.15-.26a1.41,1.41,0,0,0,.87.28c.46,0,.65-.16.65-.4,0-.64-1.58-.14-1.58-1.1,0-.4.34-.7,1-.7a1.68,1.68,0,0,1,.87.23l-.15.27a1.24,1.24,0,0,0-.72-.21c-.44,0-.63.17-.63.4,0,.66,1.58.16,1.58,1.1,0,.42-.37.7-1,.7A1.58,1.58,0,0,1,375.6,221.43Z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M380.33,220.59h-2a.91.91,0,0,0,1,.85,1,1,0,0,0,.75-.32l.18.22a1.19,1.19,0,0,1-.94.4,1.21,1.21,0,0,1-1.28-1.25,1.18,1.18,0,0,1,1.19-1.24,1.16,1.16,0,0,1,1.18,1.24Zm-2-.24H380a.87.87,0,0,0-1.73,0Z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M380.76,220.49a1.2,1.2,0,0,1,1.26-1.24,1.06,1.06,0,0,1,1,.49l-.24.16a.85.85,0,0,0-.71-.36,1,1,0,0,0,0,1.9.84.84,0,0,0,.71-.35l.24.16a1.06,1.06,0,0,1-1,.49A1.21,1.21,0,0,1,380.76,220.49Z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M384.93,221.56a.78.78,0,0,1-.52.18.64.64,0,0,1-.71-.71v-1.48h-.44v-.28h.44v-.53H384v.53h.74v.28H384V221a.39.39,0,0,0,.42.44.56.56,0,0,0,.36-.12Z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M387.56,220.59h-2a.91.91,0,0,0,1,.85,1,1,0,0,0,.75-.32l.18.22a1.19,1.19,0,0,1-.94.4,1.21,1.21,0,0,1-1.28-1.25,1.19,1.19,0,1,1,2.38,0S387.56,220.56,387.56,220.59Zm-2-.24h1.73a.87.87,0,0,0-1.73,0Z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M389.52,221.56a.78.78,0,0,1-.52.18.65.65,0,0,1-.71-.71v-1.48h-.44v-.28h.44v-.53h.33v.53h.74v.28h-.74V221a.39.39,0,0,0,.42.44.54.54,0,0,0,.36-.12Z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M392.31,219.27v2.44H392v-.44a1,1,0,0,1-.88.47,1,1,0,0,1-1-1.05v-1.42h.33v1.38c0,.52.27.79.73.79a.79.79,0,0,0,.83-.89v-1.28Z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M395.36,220.59h-2a.9.9,0,0,0,1,.85.93.93,0,0,0,.74-.32l.19.22a1.29,1.29,0,0,1-2.22-.85,1.17,1.17,0,0,1,1.19-1.24,1.16,1.16,0,0,1,1.18,1.24Zm-2-.24h1.73a.87.87,0,0,0-1.73,0Z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M397.26,219.25v.32h-.08a.79.79,0,0,0-.82.9v1.24H396v-2.44h.32v.48A.92.92,0,0,1,397.26,219.25Z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M290.36,225.76v1.51h-.31v-.38a.93.93,0,0,1-.84.41c-.55,0-.89-.29-.89-.71s.24-.69.94-.69H290v-.15c0-.42-.23-.65-.69-.65a1.23,1.23,0,0,0-.81.29l-.15-.25a1.56,1.56,0,0,1,1-.33A.86.86,0,0,1,290.36,225.76Zm-.33.78v-.4h-.76c-.47,0-.63.19-.63.44s.23.46.62.46A.78.78,0,0,0,290,226.54Z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M293.49,223.83v3.44h-.31v-.48a1.07,1.07,0,0,1-.95.51,1.25,1.25,0,0,1,0-2.49,1.06,1.06,0,0,1,.93.49v-1.47Zm-.32,2.22a.91.91,0,1,0-.91.95A.89.89,0,0,0,293.17,226.05Z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M294.33,224.06a.24.24,0,0,1,.24-.23.24.24,0,0,1,.25.23.25.25,0,0,1-.49,0Zm.08.77h.33v2.44h-.33Z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M298.13,226.05a1.19,1.19,0,0,1-1.22,1.25,1.07,1.07,0,0,1-.93-.49v1.36h-.33v-3.34H296v.49a1.06,1.06,0,0,1,.94-.51A1.19,1.19,0,0,1,298.13,226.05Zm-.33,0a.91.91,0,1,0-1.82,0,.91.91,0,1,0,1.82,0Z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M298.72,224.06a.24.24,0,0,1,.24-.23.23.23,0,0,1,.24.23.24.24,0,0,1-.24.24A.24.24,0,0,1,298.72,224.06Zm.08.77h.33v2.44h-.33Z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M299.7,227l.15-.26a1.46,1.46,0,0,0,.87.28c.46,0,.65-.16.65-.4,0-.64-1.58-.14-1.58-1.1,0-.4.34-.7,1-.7a1.67,1.67,0,0,1,.86.23l-.14.27a1.26,1.26,0,0,0-.72-.21c-.44,0-.64.17-.64.4,0,.66,1.58.16,1.58,1.1,0,.42-.37.7-1,.7A1.59,1.59,0,0,1,299.7,227Z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M302.06,226.05a1.2,1.2,0,0,1,1.26-1.24,1.09,1.09,0,0,1,1,.49l-.25.16a.85.85,0,0,0-.71-.36,1,1,0,0,0,0,1.9.84.84,0,0,0,.71-.35l.25.16a1.09,1.09,0,0,1-1,.49A1.21,1.21,0,0,1,302.06,226.05Z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M304.84,224.06a.24.24,0,0,1,.24-.23.23.23,0,0,1,.24.23.24.24,0,0,1-.24.24A.24.24,0,0,1,304.84,224.06Zm.08.77h.33v2.44h-.33Z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M308.41,225.86v1.41h-.33v-1.38a.68.68,0,0,0-.73-.78.8.8,0,0,0-.86.88v1.28h-.33v-2.44h.32v.45a1,1,0,0,1,.93-.47A.94.94,0,0,1,308.41,225.86Z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M311.57,224.83V227a1.07,1.07,0,0,1-1.22,1.22,1.72,1.72,0,0,1-1.14-.38l.17-.25a1.43,1.43,0,0,0,1,.33c.62,0,.9-.28.9-.88v-.31a1.1,1.1,0,0,1-.95.47,1.19,1.19,0,1,1,0-2.37,1.09,1.09,0,0,1,1,.49v-.47Zm-.32,1.16a.93.93,0,1,0-.93.9A.87.87,0,0,0,311.25,226Z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M315.83,226.16h-2a.89.89,0,0,0,1,.84.93.93,0,0,0,.74-.32l.19.22a1.29,1.29,0,0,1-2.22-.85,1.17,1.17,0,0,1,1.19-1.24,1.16,1.16,0,0,1,1.18,1.24Zm-2-.25h1.73a.87.87,0,0,0-1.73,0Z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M316.5,223.83h.33v3.44h-.33Z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M317.67,224.06a.24.24,0,0,1,.24-.23.24.24,0,0,1,.25.23.25.25,0,0,1-.49,0Zm.08.77h.33v2.44h-.33Z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M320.28,227.12a.76.76,0,0,1-.51.18.65.65,0,0,1-.72-.71v-1.48h-.44v-.28h.44v-.53h.33v.53h.74v.28h-.74v1.46a.39.39,0,0,0,.42.44.54.54,0,0,0,.36-.12Z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M321.2,227a.66.66,0,0,1-.06.27l-.2.64h-.22l.16-.67a.24.24,0,0,1-.17-.24.25.25,0,0,1,.25-.25A.24.24,0,0,1,321.2,227Z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M322.78,227l.15-.26a1.41,1.41,0,0,0,.87.28c.46,0,.65-.16.65-.4,0-.64-1.58-.14-1.58-1.1,0-.4.34-.7,1-.7a1.68,1.68,0,0,1,.87.23l-.15.27a1.24,1.24,0,0,0-.72-.21c-.44,0-.63.17-.63.4,0,.66,1.58.16,1.58,1.1,0,.42-.37.7-1,.7A1.58,1.58,0,0,1,322.78,227Z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M327.51,226.16h-2a.91.91,0,0,0,1,.84,1,1,0,0,0,.75-.32l.18.22a1.29,1.29,0,0,1-2.22-.85,1.17,1.17,0,0,1,1.19-1.24,1.16,1.16,0,0,1,1.18,1.24Zm-2-.25h1.73a.87.87,0,0,0-1.73,0Z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M330.41,223.83v3.44h-.32v-.48a1,1,0,0,1-.94.51,1.25,1.25,0,0,1,0-2.49,1.06,1.06,0,0,1,.93.49v-1.47Zm-.32,2.22a.91.91,0,1,0-.91.95A.89.89,0,0,0,330.09,226.05Z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M334.77,223.83v3.44h-.32v-.48a1.06,1.06,0,0,1-.94.51,1.25,1.25,0,0,1,0-2.49,1.07,1.07,0,0,1,.93.49v-1.47Zm-.33,2.22a.91.91,0,1,0-.9.95A.89.89,0,0,0,334.44,226.05Z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M335.61,224.06a.24.24,0,1,1,.24.24A.23.23,0,0,1,335.61,224.06Zm.07.77H336v2.44h-.33Z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M338.77,225.76v1.51h-.32v-.38a.9.9,0,0,1-.84.41c-.55,0-.89-.29-.89-.71s.24-.69.94-.69h.78v-.15a.6.6,0,0,0-.69-.65,1.21,1.21,0,0,0-.81.29l-.15-.25a1.53,1.53,0,0,1,1-.33A.87.87,0,0,1,338.77,225.76Zm-.33.78v-.4h-.77c-.47,0-.62.19-.62.44s.23.46.61.46A.78.78,0,0,0,338.44,226.54Z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M343.69,225.86v1.41h-.33v-1.38c0-.51-.26-.78-.7-.78a.79.79,0,0,0-.82.88v1.28h-.33v-1.38c0-.51-.26-.78-.7-.78a.79.79,0,0,0-.82.88v1.28h-.33v-2.44H340v.45a1,1,0,0,1,.89-.47.88.88,0,0,1,.87.52,1.05,1.05,0,0,1,1-.52A.93.93,0,0,1,343.69,225.86Z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M346.51,225l-1.65.64,1.65.63v.39l-2.08-.82v-.4l2.08-.82Z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M348.22,223.37h.4l-1.53,4.37h-.4Z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M351.73,224v3.24h-.47v-1.44H349.4v1.44h-.47V224h.47v1.39h1.86V224Z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M353.44,224v3.24H353v-2.84h-.73V224Z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M356.31,225.45v.4l-2.08.82v-.39l1.66-.63-1.66-.64v-.38Z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M290.45,236.14l-1.64.63,1.64.64v.38l-2.08-.82v-.4l2.08-.82Z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M293.87,236.28c0,.7-.51,1.13-1.36,1.13h-.8v1h-.46v-3.24h1.26C293.36,235.15,293.87,235.57,293.87,236.28Zm-.47,0c0-.46-.31-.73-.9-.73h-.79V237h.79C293.09,237,293.4,236.74,293.4,236.28Z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M296.49,236.57v.4l-2.07.82v-.38l1.65-.64-1.65-.63v-.39Z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M300.44,236.14l-1.65.63,1.65.64v.38l-2.08-.82v-.4l2.08-.82Z"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M301.23,235.15h.47v3.24h-.47Z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M305.68,238.39V236l-1.18,2h-.21l-1.18-2v2.35h-.44v-3.24h.38l1.35,2.28,1.34-2.28h.38v3.24Z"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M309.34,236.75h.45V238a1.92,1.92,0,0,1-1.23.41,1.66,1.66,0,1,1,1.26-2.82l-.29.29a1.28,1.28,0,0,0-.94-.38,1.25,1.25,0,1,0,0,2.5,1.34,1.34,0,0,0,.76-.21Z"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M311.62,238l.17-.36a1.67,1.67,0,0,0,1.07.38c.57,0,.81-.22.81-.5,0-.8-2-.3-2-1.5,0-.5.39-.93,1.24-.93a1.9,1.9,0,0,1,1.05.29l-.16.37a1.68,1.68,0,0,0-.89-.27c-.55,0-.79.24-.79.52,0,.79,2,.3,2,1.49,0,.49-.4.92-1.26.92A1.94,1.94,0,0,1,311.62,238Z"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M317,238.39l-.7-1h-1v1h-.46v-3.24h1.26c.85,0,1.36.42,1.36,1.13a1,1,0,0,1-.72,1l.77,1.09Zm0-2.11c0-.46-.31-.73-.9-.73h-.79V237h.79C316.64,237,317,236.74,317,236.28Z"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M317.9,236.77a1.64,1.64,0,0,1,1.72-1.66,1.61,1.61,0,0,1,1.24.51l-.31.29a1.18,1.18,0,0,0-.91-.39,1.25,1.25,0,1,0,0,2.5,1.21,1.21,0,0,0,.91-.39l.31.29a1.61,1.61,0,0,1-1.24.51A1.64,1.64,0,0,1,317.9,236.77Z"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M321.34,236h2.08v.36h-2.08Zm0,1.1h2.08v.36h-2.08Z"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M325.26,235.15h.39l0,1.25h-.33Zm.84,0h.39l0,1.25h-.33Z"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M327.27,235.15h.46V238h1.76v.4h-2.22Z"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M329.7,237.16a1.28,1.28,0,1,1,1.28,1.26A1.22,1.22,0,0,1,329.7,237.16Zm2.1,0a.83.83,0,1,0-1.65,0,.83.83,0,1,0,1.65,0Z"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M334.19,235.91v.43h-.1a.74.74,0,0,0-.78.83v1.22h-.44v-2.45h.42v.41A1,1,0,0,1,334.19,235.91Z"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M336.93,237.31h-2a.83.83,0,0,0,.89.72.91.91,0,0,0,.71-.29l.25.28a1.35,1.35,0,0,1-2.3-.86,1.21,1.21,0,0,1,1.24-1.25,1.18,1.18,0,0,1,1.21,1.27Zm-2-.32h1.58a.8.8,0,0,0-1.58,0Z"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M341.63,237v1.41h-.44V237c0-.48-.24-.72-.64-.72s-.74.28-.74.82v1.26h-.44V237c0-.48-.23-.72-.64-.72a.72.72,0,0,0-.74.82v1.26h-.44v-2.45H338v.36a1,1,0,0,1,.84-.39.91.91,0,0,1,.86.46,1.1,1.1,0,0,1,.94-.46A1,1,0,0,1,341.63,237Z"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M343.61,235.18a.3.3,0,0,1,.31-.3.29.29,0,1,1,0,.58A.29.29,0,0,1,343.61,235.18Zm.08.76h.45v2.45h-.45Z"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M347.53,237.16a1.19,1.19,0,0,1-1.24,1.26,1,1,0,0,1-.86-.4v1.27H345v-3.35h.42v.39a1,1,0,0,1,.88-.42A1.19,1.19,0,0,1,347.53,237.16Zm-.45,0a.83.83,0,1,0-.83.87A.81.81,0,0,0,347.08,237.16Z"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M347.84,238.13l.18-.35a1.56,1.56,0,0,0,.86.26c.42,0,.59-.13.59-.34,0-.55-1.56-.07-1.56-1,0-.44.4-.74,1-.74a1.75,1.75,0,0,1,.89.23l-.18.35a1.26,1.26,0,0,0-.71-.2c-.39,0-.58.15-.58.34,0,.58,1.55.11,1.55,1.06,0,.45-.4.73-1.06.73A1.68,1.68,0,0,1,347.84,238.13Z"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M352.76,235.94v2.45h-.42V238a1,1,0,0,1-.84.4,1,1,0,0,1-1.06-1.07v-1.41h.45v1.36c0,.48.24.72.66.72a.71.71,0,0,0,.76-.81v-1.27Z"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M357.69,237v1.41h-.45V237c0-.48-.23-.72-.63-.72s-.74.28-.74.82v1.26h-.45V237c0-.48-.23-.72-.63-.72s-.74.28-.74.82v1.26h-.44v-2.45H354v.36a1,1,0,0,1,.85-.39.9.9,0,0,1,.85.46,1.12,1.12,0,0,1,.95-.46A1,1,0,0,1,357.69,237Z"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M358.37,235.15h.39l0,1.25h-.33Zm.84,0h.39l0,1.25h-.33Z"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M362.28,236.57v.4l-2.08.82v-.38l1.65-.64-1.65-.63v-.39Z"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M365,236.14l-1.65.63,1.65.64v.38L362.9,237v-.4l2.08-.82Z"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M366.69,234.49h.4l-1.53,4.37h-.4Z"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M370,236.28c0,.7-.51,1.13-1.36,1.13h-.8v1h-.47v-3.24h1.27C369.52,235.15,370,235.57,370,236.28Zm-.47,0c0-.46-.31-.73-.9-.73h-.79V237h.79C369.25,237,369.56,236.74,369.56,236.28Z"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M372.65,236.57v.4l-2.08.82v-.38l1.66-.64-1.66-.63v-.39Z"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M290.45,247.26l-1.64.63,1.64.64v.38l-2.08-.82v-.4l2.08-.82Z"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M292.16,245.61h.41L291,250h-.4Z"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M295.67,248.64c0,.56-.42.88-1.24.88h-1.55v-3.25h1.45c.75,0,1.17.31,1.17.84a.76.76,0,0,1-.44.72A.79.79,0,0,1,295.67,248.64Zm-2.33-2v1h1c.48,0,.75-.17.75-.52s-.27-.52-.75-.52Zm1.86,2c0-.37-.28-.54-.79-.54h-1.07v1.08h1.07C294.92,249.14,295.2,249,295.2,248.6Z"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M296.12,247.89a1.73,1.73,0,1,1,1.73,1.66A1.65,1.65,0,0,1,296.12,247.89Zm3,0a1.26,1.26,0,1,0-1.26,1.25A1.22,1.22,0,0,0,299.11,247.89Z"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M300.28,246.27h1.37a1.63,1.63,0,1,1,0,3.25h-1.37Zm1.34,2.84a1.22,1.22,0,1,0,0-2.44h-.88v2.44Z"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M305.21,248.39v1.13h-.46v-1.14l-1.29-2.11h.5l1,1.71,1-1.71h.46Z"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M308.87,247.69v.4l-2.08.82v-.38l1.65-.64-1.65-.63v-.39Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M415.21,160.36c0,.15-32.09.26-71.67.26s-71.68-.11-71.68-.26,32.08-.26,71.68-.26S415.21,160.22,415.21,160.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.15,155.24a.92.92,0,1,1-.92-.92A.93.93,0,0,1,276.15,155.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 278.77,
    cy: 155.24,
    r: 0.92,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.24,155.24a.93.93,0,1,1-.92-.92A.93.93,0,0,1,283.24,155.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281,268.78c-.14,0-.26-24.33-.26-54.33s.12-54.34.26-54.34.26,24.32.26,54.34S281.1,268.78,281,268.78Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.21,
    y: 54.78,
    width: 59.25,
    height: 42.24,
    style: {
      fill: "#1A1C20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.93,61.05c0,.14-13.38.26-29.87.26s-29.88-.12-29.88-.26,13.38-.26,29.88-.26S139.93,60.9,139.93,61.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.05,58a.81.81,0,1,1-.8-.7A.75.75,0,0,1,85.05,58Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88,58a.74.74,0,0,1-.79.7A.71.71,0,1,1,88,58Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 90.06,
    cy: 57.96,
    rx: 0.8,
    ry: 0.7,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.12,77.89c0,2.54-1.83,4.07-4.86,4.07h-3.2v3.76H92.8V73.81h4.46C100.29,73.81,102.12,75.34,102.12,77.89Zm-1.25,0c0-1.9-1.26-3-3.65-3H94.06v5.95h3.16C99.61,80.85,100.87,79.76,100.87,77.89Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.79,73.81V85.72h-1.24v-5.5H106.1v5.5h-1.26V73.81h1.26v5.31h7.45V73.81Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128,77.89c0,2.54-1.83,4.07-4.86,4.07h-3.2v3.76h-1.26V73.81h4.46C126.16,73.81,128,75.34,128,77.89Zm-1.26,0c0-1.9-1.26-3-3.64-3h-3.16v5.95h3.16C125.47,80.85,126.73,79.76,126.73,77.89Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402.39,
    y: 216.3,
    width: 53.56,
    height: 38.18,
    style: {
      fill: "#1A1C20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.45,234v7.58H418.7v-3.1h-3.44v3.1H413.5V234h1.76v3h3.44v-3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.82,235.46h-2.43V234H428v1.43h-2.43v6.15h-1.75Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.13,234h1.76v6.15h3.8v1.43h-5.56Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.56,241.61v-4.54l-2.23,3.74h-.79l-2.22-3.65v4.45h-1.65V234h1.45l2.84,4.71,2.79-4.71h1.44l0,7.58Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.37,222c0,.09-12.09.17-27,.17s-27-.08-27-.17,12.09-.17,27-.17S456.37,221.88,456.37,222Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.76,219.18a.73.73,0,0,1-1.44,0,.73.73,0,0,1,1.44,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.39,219.18a.73.73,0,0,1-1.44,0,.73.73,0,0,1,1.44,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412,219.18a.73.73,0,1,1-.72-.63A.68.68,0,0,1,412,219.18Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.78,
    y: 215.76,
    width: 39.49,
    height: 28.15,
    style: {
      fill: "#1A1C20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.57,219.93c0,.07-8.91.13-19.9.13s-19.91-.06-19.91-.13,8.91-.12,19.91-.12S91.57,219.86,91.57,219.93Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55,217.88a.5.5,0,0,1-.53.46.49.49,0,0,1-.53-.46.5.5,0,0,1,.53-.47A.5.5,0,0,1,55,217.88Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.94,217.88a.54.54,0,0,1-1.07,0,.54.54,0,0,1,1.07,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.88,217.88a.54.54,0,1,1-.54-.47A.51.51,0,0,1,58.88,217.88Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.05,107.29a7.4,7.4,0,0,1,7.67-7.51,7.07,7.07,0,0,1,5.27,2l-.68.7a6.18,6.18,0,0,0-4.54-1.75,6.51,6.51,0,1,0,0,13,6.2,6.2,0,0,0,4.54-1.78l.68.7a7.09,7.09,0,0,1-5.27,2.07A7.39,7.39,0,0,1,287.05,107.29Z",
    style: {
      fill: "#1A1C20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302,112.78l.48-.8a7.08,7.08,0,0,0,4.88,1.86c3,0,4.27-1.29,4.27-2.9,0-4.44-9.23-1.77-9.23-7.22,0-2.1,1.6-3.94,5.24-3.94a7.89,7.89,0,0,1,4.46,1.34l-.4.86a7.37,7.37,0,0,0-4.06-1.24c-2.88,0-4.16,1.33-4.16,3,0,4.44,9.23,1.82,9.23,7.19,0,2.09-1.67,3.91-5.33,3.91A7.58,7.58,0,0,1,302,112.78Z",
    style: {
      fill: "#1A1C20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.88,112.78l.49-.8a7.06,7.06,0,0,0,4.88,1.86c3,0,4.27-1.29,4.27-2.9,0-4.44-9.23-1.77-9.23-7.22,0-2.1,1.6-3.94,5.24-3.94a7.94,7.94,0,0,1,4.46,1.34l-.4.86a7.37,7.37,0,0,0-4.06-1.24c-2.88,0-4.17,1.33-4.17,3,0,4.44,9.24,1.82,9.24,7.19,0,2.09-1.67,3.91-5.33,3.91A7.62,7.62,0,0,1,314.88,112.78Z",
    style: {
      fill: "#1A1C20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.19,126.52s0-.27,0-.78,0-1.28,0-2.26c0-2,0-4.87-.06-8.56,0-7.39-.06-18-.1-31l.2.21-65.88,0h0l.26-.26c0,15.12,0,29.51,0,42.56l-.24-.24,47.4.12,13.59.06,3.63,0,.94,0h0l-.91,0-3.58,0-13.54.06-47.56.12h-.24v-.24c0-13,0-27.44,0-42.56V83.7h.27l65.88.06h.21V84c0,13-.08,23.67-.11,31.09,0,3.67,0,6.54-.05,8.52,0,1,0,1.69,0,2.21S338.19,126.52,338.19,126.52Z",
    style: {
      fill: "#1A1C20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.19,90.28c0,.14-14.76.26-33,.26s-33-.12-33-.26S287,90,305.23,90,338.19,90.13,338.19,90.28Z",
    style: {
      fill: "#1A1C20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.17,87.17a.81.81,0,1,1-.8-.7A.75.75,0,0,1,277.17,87.17Z",
    style: {
      fill: "#1A1C20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.1,87.17a.81.81,0,1,1-.8-.7A.75.75,0,0,1,280.1,87.17Z",
    style: {
      fill: "#1A1C20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283,87.17a.81.81,0,1,1-.8-.7A.75.75,0,0,1,283,87.17Z",
    style: {
      fill: "#1A1C20"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147.88,272,174,360.13a9.23,9.23,0,0,0,8.84,6.61l106,.29a9.81,9.81,0,0,0,9.82-10.32h0a9.81,9.81,0,0,0-9.79-9.28H248.34L215.88,257H159.06A11.66,11.66,0,0,0,147.88,272Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.56,354.67c0,.21-10.81.37-24.14.37s-24.13-.16-24.13-.37,10.8-.37,24.13-.37S237.56,354.46,237.56,354.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.68,259.78c.19-.06,7.41,21.05,16.12,47.16s15.6,47.33,15.41,47.39-7.41-21-16.12-47.16S155.48,259.85,155.68,259.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "233.15 445.09 226.69 444.94 226.69 366.74 233.15 366.74 233.15 445.09",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "199.86 444.73 259.99 444.73 232.75 435.26 226.29 435.26 199.86 444.73",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.65,236.76l9.95,49.71-1.78,37.25L259.7,312.6,257.08,280,257,253l16.4,31.78,12.76-24.67-23.37-42.35h0a39.47,39.47,0,0,0-15.29-9.9,31.37,31.37,0,0,0-9.59-1.84h0a38.35,38.35,0,0,1-23.15,0c-.94.12-2.24.25-3.89.44l-.3,0a29.57,29.57,0,0,0-25.81,27.8Z",
    style: {
      fill: "#1A1C20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.89,206.47s-27.48.21-30.88,29.23L179.55,257l23.66-.2Z",
    style: {
      fill: "#1A1C20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.54,243.8c0,.21-21.62.38-48.29.38S180,244,180,243.8s21.61-.37,48.29-.37S276.54,243.6,276.54,243.8Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.54,248.41c0,.2-21.62.37-48.29.37s-48.29-.17-48.29-.37,21.61-.38,48.29-.38S276.54,248.2,276.54,248.41Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275,240c0,.21-21.27.38-47.51.38S180,240.2,180,240s21.27-.37,47.52-.37S275,239.79,275,240Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.67,284.77c-.21,0-.12-11.77.2-26.27s.75-26.26.95-26.26.12,11.77-.2,26.27S256.87,284.77,256.67,284.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.27,265.69s13,.93,15.34,4.37,5.91,13.23,4.56,13.3a3.68,3.68,0,0,1-2.34-.73l-3.56-6.32s.57,6.1-1.56,6.22S247,284.77,247,284.77Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.56,251.32l-.05,33.51a12.73,12.73,0,0,0,15.42,11.75l52.41-10.8-.11-21.49L202,273l-.6-22.75Z",
    style: {
      fill: "#1A1C20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.46,293.89a4.51,4.51,0,0,1,.69-.19l2-.46,7.7-1.63L247.16,286l-.27.32c0-6.74,0-14.2,0-22.07l.44.37-9.22,1.77-36,6.85-.39.08V273c.34-10,.63-18.28.83-24.16.12-2.86.21-5.13.28-6.75,0-.73.07-1.32.1-1.77a2.7,2.7,0,0,1,.07-.61,4.81,4.81,0,0,1,0,.61c0,.46,0,1,0,1.78,0,1.62-.06,3.89-.1,6.75-.14,5.89-.33,14.19-.56,24.16l-.38-.31,36-7,9.22-1.76.44-.09v.45c0,7.87,0,15.33,0,22.07v.28l-.27.05L220,292l-7.74,1.45-2.05.36A3.47,3.47,0,0,1,209.46,293.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.52,206.47s.1.16.21.49a10.15,10.15,0,0,1,.41,1.48,12.09,12.09,0,0,1-.25,5.64,14.82,14.82,0,0,1-4.54,7,14.14,14.14,0,0,1-9.54,3.61,13,13,0,0,1-9.43-3.83,13.25,13.25,0,0,1-3.51-7.59,11.86,11.86,0,0,1,.66-5.61,7.74,7.74,0,0,1,.67-1.38c.18-.3.28-.45.31-.44s-.32.67-.71,1.92a12.65,12.65,0,0,0-.41,5.44,13,13,0,0,0,3.48,7.18,12.42,12.42,0,0,0,8.94,3.56,13.62,13.62,0,0,0,9.08-3.37,14.63,14.63,0,0,0,4.5-6.66,12.67,12.67,0,0,0,.46-5.44C239.68,207.19,239.44,206.49,239.52,206.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.05,287.56a15.75,15.75,0,0,1,0-3.31c.08-2,.18-4.84.2-7.94s0-5.91-.11-7.95a16.25,16.25,0,0,1,0-3.31,13.2,13.2,0,0,1,.5,3.28c.19,2,.34,4.86.32,8s-.2,5.94-.41,8A13.55,13.55,0,0,1,242.05,287.56Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.34,288.11a16.38,16.38,0,0,1-.09-3.29c0-2.31.05-5,.08-7.89V269a15.45,15.45,0,0,1,.12-3.28,13.33,13.33,0,0,1,.41,3.26c.13,2,.24,4.83.22,7.92s-.14,5.89-.3,7.92A13.58,13.58,0,0,1,239.34,288.11Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.83,421.25l9.9,27.28,14.06,19.31a3,3,0,0,1-.83,4.27h0a3,3,0,0,1-2.71.23c-5.67-2.35-26.47-11.11-27.09-13.14-.71-2.36-14.14-31.7-14.14-31.7Z",
    style: {
      fill: "#1A1C20"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M315,472.11l-30.51-14.74.45,1.15a4.54,4.54,0,0,0,2,2.32c2.5,1.35,9.5,4.92,25.23,11.53a3,3,0,0,0,2.79-.26Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M286.61,446.49a1.79,1.79,0,0,1,1.31,2,1.73,1.73,0,0,1-2,1.32,1.89,1.89,0,0,1-1.38-2.14,1.8,1.8,0,0,1,2.21-1.14",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M304.18,462.7a8.91,8.91,0,0,1,1.56-3c1.27-1.42,2.91-1.63,2.88-1.81s-.43-.15-1.1,0a4.76,4.76,0,0,0-3.43,3.74C304,462.29,304.11,462.7,304.18,462.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.52,465.57c.17.07.7-1.15,1.94-2.1a22.3,22.3,0,0,1,2.51-1.36c0-.17-1.5-.24-2.9.86S307.35,465.55,307.52,465.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.79,459.45c.18.08,1-1.79,2.78-3.43s3.71-2.32,3.65-2.5-2.17.24-4.08,2S298.63,459.43,298.79,459.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.09,451.41c.13.14,1.38-1.07,3.3-1.9s3.64-1,3.63-1.15-1.84-.34-3.89.57S295,451.32,295.09,451.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292,443.48c.14.12,1.29-1.36,3.38-2.07s3.9-.31,3.94-.49-.41-.3-1.17-.42a6.5,6.5,0,0,0-5.5,1.92C292.11,443,291.91,443.43,292,443.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.73,439.92a2.66,2.66,0,0,0-.37-1,7.61,7.61,0,0,0-1.85-2.36,3.36,3.36,0,0,0-1.94-1,1.2,1.2,0,0,0-1.16.74,1.93,1.93,0,0,0,0,1.38A4.2,4.2,0,0,0,294.3,440a4.86,4.86,0,0,0,3.54-4.11,1.7,1.7,0,0,0-.43-1.34,1.19,1.19,0,0,0-1.37-.14,4.16,4.16,0,0,0-1.42,1.62,8.69,8.69,0,0,0-1,2.82,2.46,2.46,0,0,0,0,1.1,13.23,13.23,0,0,1,1.46-3.68,3.92,3.92,0,0,1,1.27-1.38.62.62,0,0,1,.75.07,1.16,1.16,0,0,1,.24.89,4.36,4.36,0,0,1-3.11,3.53,3.63,3.63,0,0,1-4.14-1.88,1.39,1.39,0,0,1-.08-1,.65.65,0,0,1,.64-.41,3.05,3.05,0,0,1,1.65.8A11.13,11.13,0,0,1,294.73,439.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.64,414.11l-.85,22.17s22.24,8.32,22.48,12.43l-43-.12L312.15,414Z",
    style: {
      fill: "#1A1C20"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M319.48,434.38a1.76,1.76,0,0,0-1.22,2,1.69,1.69,0,0,0,2,1.23,1.86,1.86,0,0,0,1.28-2.13,1.77,1.77,0,0,0-2.2-1.05",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M312.23,448.59v-3.45l41.36,1.38s1.91.84,1.69,2.19Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M333.48,436.06c0,.21-1.05.31-2.09,1s-1.59,1.56-1.78,1.47.12-1.3,1.39-2.09S333.53,435.87,333.48,436.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338,437.94c.05.21-.86.56-1.58,1.45s-.92,1.83-1.13,1.82-.34-1.2.57-2.29S338,437.74,338,437.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.54,443.35c-.19,0-.48-1,.07-2.15s1.52-1.61,1.61-1.43-.52.79-1,1.74S340.75,443.33,340.54,443.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.12,431c-.09.19-1.05-.1-2.24,0s-2.12.45-2.23.27.79-.93,2.19-1S333.22,430.83,333.12,431Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "333.47 418.5 333.32 422.45 312.17 422.2 312.15 418.64 333.47 418.5"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M333.21,426.52a4.19,4.19,0,0,1-2.16,0,10.17,10.17,0,0,1-2.25-.7,10,10,0,0,1-1.24-.66,3,3,0,0,1-.65-.51.92.92,0,0,1-.09-1.12,1.16,1.16,0,0,1,.92-.48,2.71,2.71,0,0,1,.81.12,8.43,8.43,0,0,1,1.34.46,7.56,7.56,0,0,1,2,1.31c1,.93,1.34,1.71,1.27,1.76s-.58-.59-1.6-1.36a8.37,8.37,0,0,0-1.92-1.09,7.37,7.37,0,0,0-1.23-.38c-.46-.13-.85-.13-1,.07s-.05.11,0,.24a2.23,2.23,0,0,0,.48.38,11,11,0,0,0,1.14.65,12.11,12.11,0,0,0,2.08.8A13.74,13.74,0,0,1,333.21,426.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.93,426.82a3.59,3.59,0,0,1-.56-2.09,7.2,7.2,0,0,1,.3-2.36,8,8,0,0,1,.55-1.3A1.8,1.8,0,0,1,334.6,420a1,1,0,0,1,.9.6,3.12,3.12,0,0,1,.22.8,4.7,4.7,0,0,1,0,1.45,5,5,0,0,1-.93,2.22c-.84,1.11-1.72,1.36-1.74,1.29s.67-.51,1.31-1.58a4.82,4.82,0,0,0,.69-2,4.4,4.4,0,0,0,0-1.25c-.06-.45-.23-.82-.4-.78s-.58.34-.76.71a7.54,7.54,0,0,0-.54,1.16,7.74,7.74,0,0,0-.42,2.15C332.83,426,333.05,426.78,332.93,426.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.19,307.84c-25.43,2.63-59.14,6.09-59.14,6.09l4.6,41.39s49.52-13.09,49.17-12,2.3,88.06,2.3,88.06h29.82l.56-98.53A24.77,24.77,0,0,0,312.19,307.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.21,324.54v12.83c0,8.74,9.95,18,18.68,18h6.76c5.32,0,13.66-3.88,18-7l2.58-1.89,31.06,96.21s35.53-6.37,35.53-7.49-24.06-78.8-35.17-114.85c-4.54-14.72-20.31-23.28-34.88-18.29-.49.17-1,.36-1.49.56C217.32,309,192.21,324.54,192.21,324.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.78,435.19a1.79,1.79,0,0,1-.15-.34c-.11-.27-.24-.61-.4-1-.34-.91-.83-2.25-1.41-4-1.19-3.47-2.82-8.54-4.8-14.81-4-12.53-9.28-29.9-15.06-49.1-2.88-9.61-5.61-18.76-8.11-27.1-1.24-4.16-2.41-8.12-3.51-11.83q-.84-2.78-1.6-5.35a47.09,47.09,0,0,0-1.62-4.87,20,20,0,0,0-5-7.11,42.9,42.9,0,0,0-5.26-4.09c-1.52-1-2.73-1.77-3.56-2.27l-.93-.59a1.25,1.25,0,0,1-.31-.22,1.28,1.28,0,0,1,.34.16l1,.52c.85.46,2.09,1.17,3.64,2.16a39.78,39.78,0,0,1,5.38,4,20.14,20.14,0,0,1,5.22,7.2,47.09,47.09,0,0,1,1.68,4.91c.53,1.71,1.07,3.5,1.64,5.35l3.58,11.8c2.51,8.33,5.27,17.48,8.17,27.08,5.78,19.17,11,36.53,14.84,49.17l4.58,14.87,1.28,4c.13.43.23.77.32,1.05S304.8,435.19,304.78,435.19Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.28,330.88c.18.12-1.51,2.66-2.92,6.11s-2.05,6.43-2.27,6.39.1-3.14,1.58-6.68S312.13,330.76,312.28,330.88Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318,334.88c.08.2-2.48,1.33-5.15,3.44s-4.39,4.32-4.57,4.19,1.32-2.6,4.11-4.77S317.93,334.7,318,334.88Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.58,442.68c-.19.06-8.58-25.68-18.74-57.5s-18.22-57.67-18-57.73,8.58,25.68,18.74,57.51S269.78,442.62,269.58,442.68Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "231.47 292.59 333.12 293.57 352.08 239.99 278.14 240.49 260.98 288.67 231.47 289.12 231.47 292.59",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.54,271.4a4.12,4.12,0,1,1,4.65-3.5A4.12,4.12,0,0,1,308.54,271.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.17,147.57c1-3.57,3.65-5.32,7.14-6.51a11.48,11.48,0,0,1,10.5,1.7c2,1.5,3.5,3.67,5.84,4.48,3.84,1.33,8.34-1.54,12,.18a5.24,5.24,0,0,1-2.48,10c2.5.92,3.28,4.49,1.82,6.72s-4.47,3.07-7.1,2.58a14.72,14.72,0,0,1-6.89-3.86c-2-1.78-3.76-3.8-5.88-5.42a11.41,11.41,0,0,0-7.36-2.7c-3.61.19-6.7,2.91-8.31,6.15s-2,6.92-2.18,10.53-.26,7.27-1.33,10.72c-.13.41-.32.86-.72,1-.59.18-1.09-.44-1.38-1a53,53,0,0,1-6.05-19.71c-.41-4-.31-7.78,1.89-11.15s7.75-5.84,10.47-3.71",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.2,164.3l-1.85,40.46c-.31,6.88.64,17.06,11.54,17.06h0c9.46-.72,12.25-9.56,12.54-16,.13-3,.25-5.58.29-5.89,0,0,10.34-.5,11.55-10.66.58-4.91,1-15.13,1.2-24.37a19.07,19.07,0,0,0-17-19.43l-1-.1C222.8,144.88,216.41,153.64,216.2,164.3Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.75,199.8a23.76,23.76,0,0,1-12.86-5.18s2.35,7.65,12.6,7.82Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.78,171.42a1.46,1.46,0,0,1-1.56,1.32,1.39,1.39,0,0,1-1.35-1.47,1.46,1.46,0,0,1,1.55-1.32A1.39,1.39,0,0,1,247.78,171.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.75,169.68c-.2.17-1.21-.76-2.78-.92s-2.79.5-2.94.29.15-.42.69-.73a4.05,4.05,0,0,1,2.38-.47,3.82,3.82,0,0,1,2.18,1C248.72,169.25,248.85,169.61,248.75,169.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.39,170.32a1.46,1.46,0,0,1-1.56,1.32,1.41,1.41,0,0,1-1.36-1.47,1.48,1.48,0,0,1,1.56-1.32A1.4,1.4,0,0,1,232.39,170.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.35,168.34c-.2.17-1.21-.76-2.78-.93s-2.79.5-2.94.29.15-.41.69-.72a4,4,0,0,1,2.38-.47,3.89,3.89,0,0,1,2.18,1C233.32,167.9,233.45,168.26,233.35,168.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.79,180.54a10.23,10.23,0,0,1,2.59-.19c.41,0,.79,0,.89-.3a2.15,2.15,0,0,0-.14-1.22c-.28-1-.56-2.06-.86-3.16-1.18-4.5-2-8.19-1.81-8.24s1.29,3.57,2.47,8.07c.28,1.11.55,2.17.8,3.18a2.27,2.27,0,0,1,0,1.59,1,1,0,0,1-.71.52,2.74,2.74,0,0,1-.69,0A10.67,10.67,0,0,1,237.79,180.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.08,181.13c.25,0,.08,1.71,1.4,3.07s3.15,1.36,3.14,1.6-.44.29-1.21.23a4.28,4.28,0,0,1-2.63-1.25,3.69,3.69,0,0,1-1.06-2.56C232.73,181.51,233,181.11,233.08,181.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.41,162.25c-.2.41-1.74,0-3.6.07s-3.39.37-3.6,0c-.08-.19.22-.56.86-.91a6.19,6.19,0,0,1,5.48,0C234.19,161.69,234.5,162.06,234.41,162.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.66,165.1c-.31.32-1.35-.16-2.64-.32s-2.42,0-2.63-.41c-.1-.19.11-.53.63-.82a3.73,3.73,0,0,1,2.21-.35,3.67,3.67,0,0,1,2,.94C248.69,164.55,248.8,164.94,248.66,165.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.23,171.92c-.17-.09-6.77-2.81-7.29,4.17s6.6,6.06,6.62,5.86S216.23,171.92,216.23,171.92Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.63,179.15s-.13.08-.34.16a1.27,1.27,0,0,1-.91-.05,3.05,3.05,0,0,1-1.2-2.81,4.05,4.05,0,0,1,.47-1.71,1.42,1.42,0,0,1,1-.87.63.63,0,0,1,.69.39c.08.2,0,.34.06.35s.16-.1.13-.4a.74.74,0,0,0-.25-.45.9.9,0,0,0-.66-.23,1.73,1.73,0,0,0-1.35,1,4.19,4.19,0,0,0-.56,1.91c-.06,1.41.56,2.78,1.55,3.15a1.3,1.3,0,0,0,1.12-.11C213.6,179.32,213.65,179.16,213.63,179.15Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.85,163a14.81,14.81,0,0,1-12.74-4.33c-2.25-2.36-3.84-5.58-6.84-6.87a8.34,8.34,0,0,0-6.41.19,16,16,0,0,0-5.26,3.9c1.41,5.38-.52,11-2.43,16.23a2.79,2.79,0,0,1-1,1.52c-.89.55-2.07-.08-2.71-.91a8.63,8.63,0,0,1-1.4-4.73,28.69,28.69,0,0,1,1.26-11.28,19.68,19.68,0,0,1,6.4-9.26A18.54,18.54,0,0,1,236.21,144a22.75,22.75,0,0,1,12.64,6.09,13.33,13.33,0,0,1,3.75,5.38",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.32,378.08A18.91,18.91,0,0,1,70,376.65c2.12.35,4.34,1,5.79,2.59s1.72,4.41.06,5.78a5.56,5.56,0,0,1-3.65.92c-3.1,0-6.54-.58-9,1.29-1.42,1.06-2.36,2.83-4,3.35a4,4,0,0,1-4.39-1.95,6.86,6.86,0,0,1-.49-5A7.68,7.68,0,0,1,58.32,378.08Z",
    style: {
      fill: "#1A1C20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.15,362.31c2.18,3.11,6.42,2.08,8.38.18s2.8-4.65,3.55-7.28c1.73-6,3.47-12.3,2.19-18.41a10.23,10.23,0,0,0-2.36-5,5.34,5.34,0,0,0-5.06-1.69c-2.13.57-3.46,2.66-4.42,4.65a43.87,43.87,0,0,0-4.34,18.83c0,3,.35,6.22,2.06,8.72",
    style: {
      fill: "#1A1C20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.16,366.78a11.34,11.34,0,0,0,1.77-10.43,20.13,20.13,0,0,0-6.18-9,33.15,33.15,0,0,0-11-6.53,11.86,11.86,0,0,0-5-.84,5.22,5.22,0,0,0-4.17,2.52c-1.16,2.22-.05,4.91,1.16,7.11A84.27,84.27,0,0,0,28,360.72c2.18,2.8,4.67,5.57,8,6.84s6.76,1.12,8.52-1.18",
    style: {
      fill: "#1A1C20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50,409.27a6.52,6.52,0,0,0,.2-1.41c.1-1,.23-2.32.38-3.86a55.86,55.86,0,0,1,.86-5.66,44.36,44.36,0,0,1,2.06-6.69,24.73,24.73,0,0,1,3.42-6A12.72,12.72,0,0,1,61.23,382a11.62,11.62,0,0,1,3.63-1.13,7,7,0,0,0,1.41-.21,7.14,7.14,0,0,0-1.43,0,10.81,10.81,0,0,0-3.79,1,12.58,12.58,0,0,0-4.55,3.61A24.24,24.24,0,0,0,53,391.43a40.82,40.82,0,0,0-2,6.8,47.89,47.89,0,0,0-.76,5.73c-.12,1.64-.16,3-.19,3.89A6.56,6.56,0,0,0,50,409.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.27,406.3a3,3,0,0,0,0-.65c0-.5,0-1.12,0-1.88,0-1.63,0-4,.09-6.9.14-5.82.64-12.09,1.61-20.92.92-8.31,2.15-18,3.45-24.26.27-1.43.55-2.72.82-3.84s.47-2.1.67-2.89.33-1.35.44-1.83a2.62,2.62,0,0,0,.12-.64,2.37,2.37,0,0,0-.23.61c-.15.47-.33,1.07-.55,1.8s-.49,1.75-.77,2.87-.6,2.41-.91,3.83a215.52,215.52,0,0,0-3.62,22.51C50.45,383,50,391,50,396.87c0,2.91,0,5.28.1,6.91,0,.76.09,1.38.12,1.87A2.46,2.46,0,0,0,50.27,406.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.31,390.76a12.76,12.76,0,0,0,0-2,52.54,52.54,0,0,0-.6-5.32A70.48,70.48,0,0,0,48,375.74a63.67,63.67,0,0,0-3.24-9.16,48.93,48.93,0,0,0-9.51-14.8A25.58,25.58,0,0,0,33,349.7c-.35-.29-.65-.57-1-.8l-.87-.6a12.35,12.35,0,0,0-1.65-1.06,58.19,58.19,0,0,1,5.41,4.83,51.27,51.27,0,0,1,9.27,14.75,72.46,72.46,0,0,1,3.26,9.07c.85,2.85,1.41,5.46,1.84,7.66s.64,4,.78,5.27A11.71,11.71,0,0,0,50.31,390.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "35.28 418.18 36.84 439.52 64.26 439.52 65.81 418.18 35.28 418.18",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.63,
    y: 409.77,
    width: 36.45,
    height: 8.41,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "32.63 438.71 32.63 441.04 34.34 441.04 68.48 441.04 68.48 438.71 32.63 438.71",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "36.02 445.14 34.34 441.04 67.18 441.04 65.22 445.14 36.02 445.14",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.31,425.16a2.07,2.07,0,0,1-.13.19l-.41.55-1.6,2-.07.09-.07-.09-3.92-5.43h.22L55.47,428l-.12.17-.14-.16c-1.42-1.7-3-3.54-4.58-5.45h.26c-.07.1-.16.2-.25.31L46.55,428l-.14.17-.13-.18-3.86-5.47h.22L37.88,428l-.08.09-.07-.11c-.62-1.05-1.12-1.89-1.49-2.5l-.38-.67-.12-.23s.07.06.16.21l.43.64,1.56,2.46-.15,0,4.69-5.48.11-.14.11.15,3.9,5.44h-.26l4.09-5.14.25-.32.13-.16.13.16,4.57,5.46H55.2l3.91-5.44.11-.16.11.16,3.84,5.48H63l1.67-2,.44-.52C65.24,425.21,65.3,425.15,65.31,425.16Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.2,418c0,.1-6.87.17-15.35.17s-15.34-.07-15.34-.17,6.87-.17,15.34-.17S66.2,418,66.2,418Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.58,441.27c0,.09-7.47.17-16.67.17s-16.68-.08-16.68-.17,7.47-.17,16.68-.17S67.58,441.18,67.58,441.27Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Devices--inject-15"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "391.71 195.56 372.66 275.23 377.99 275.23 396.75 195.56 391.71 195.56",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.39,248c-.34,1.46,8.63,44.89,8.63,44.89H388.7l-6.77-34.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 358.6,
    y: 350.33,
    width: 89.23,
    height: 94.59,
    style: {
      fill: "#1A1C20"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 447.82,
    y: 364.15,
    width: 4.38,
    height: 4.38,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 447.82,
    y: 378.06,
    width: 4.38,
    height: 4.38,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 447.82,
    y: 391.97,
    width: 4.38,
    height: 4.38,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 447.82,
    y: 405.88,
    width: 4.38,
    height: 4.38,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.37,393.25a7,7,0,0,1,1.34-.29,21.33,21.33,0,0,1,3.76-.36,10.09,10.09,0,0,1,5.42,1.43,6.26,6.26,0,0,1,3,6,7.55,7.55,0,0,1-1.14,3.43,9,9,0,0,1-2.3,2.44,11.75,11.75,0,0,1-5.22,2.06,16.93,16.93,0,0,1-3.77.13,6,6,0,0,1-1.37-.19,8.53,8.53,0,0,1,1.37,0,19.94,19.94,0,0,0,3.71-.29,11.71,11.71,0,0,0,5-2.08,7.69,7.69,0,0,0,3.21-5.53,5.8,5.8,0,0,0-2.75-5.56,9.93,9.93,0,0,0-5.17-1.46,26,26,0,0,0-3.72.19A6.7,6.7,0,0,1,452.37,393.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.28,379.42a1.84,1.84,0,0,1,.41-.25,9.06,9.06,0,0,1,1.3-.52,10.23,10.23,0,0,1,5.13-.29,4.68,4.68,0,0,1,1.63.65,2.83,2.83,0,0,1,1.15,1.56,4.75,4.75,0,0,1-2.85,5.35,2.91,2.91,0,0,1-2.41-.13,2.47,2.47,0,0,1-1.39-2.1,2.52,2.52,0,0,1,1.42-2.17,3.84,3.84,0,0,1,2.55-.27,5.42,5.42,0,0,1,2.23,1.06,6,6,0,0,1,2.22,4,5.58,5.58,0,0,1-1.14,4,8.08,8.08,0,0,1-2.74,2.31,13,13,0,0,1-5,1.3c-.6.05-1.07.07-1.39.07a1.56,1.56,0,0,1-.49,0s.67-.09,1.86-.24a13.87,13.87,0,0,0,4.82-1.42,7.85,7.85,0,0,0,2.57-2.25,5.21,5.21,0,0,0,1-3.65,5.53,5.53,0,0,0-2.06-3.63,4.79,4.79,0,0,0-2-.95,3.41,3.41,0,0,0-2.21.22,2,2,0,0,0-1.14,1.71,2,2,0,0,0,1.11,1.65,2.37,2.37,0,0,0,2,.11,3.9,3.9,0,0,0,1.65-1.2,4.06,4.06,0,0,0,1-3.56,3,3,0,0,0-2.45-2,10.56,10.56,0,0,0-5,.12C451.89,379.15,451.3,379.47,451.28,379.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.32,365.85a2.37,2.37,0,0,1,1-.18A7,7,0,0,1,455,366a7.56,7.56,0,0,1,3.33,2.25,7.35,7.35,0,0,1,1.73,4.6,7.45,7.45,0,0,1-1.44,4.7A7.54,7.54,0,0,1,455.4,380a7,7,0,0,1-2.65.54,2.31,2.31,0,0,1-1-.12,9.88,9.88,0,0,0,3.48-.75,7.49,7.49,0,0,0,2.95-2.4,7.29,7.29,0,0,0-.26-8.7,7.63,7.63,0,0,0-3.09-2.21A9.85,9.85,0,0,0,451.32,365.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.09,300.07a8.61,8.61,0,0,1,.75,1.77,33.75,33.75,0,0,1,1.19,5.37c.37,2.36.68,5.27,1,8.64s.59,7.23,1.13,11.46c.14,1.05.31,2.13.53,3.22a14.18,14.18,0,0,0,1,3.22,11.75,11.75,0,0,0,2.19,2.7,17.1,17.1,0,0,0,10.09,4.68,14.2,14.2,0,0,0,7.88-1.36,9.55,9.55,0,0,0,5.09-6.4,7.35,7.35,0,0,0-.3-4.25,7.51,7.51,0,0,0-2.77-3.35,8.32,8.32,0,0,0-4.22-1.4,6.67,6.67,0,0,0-4.27,1.25,4.68,4.68,0,0,0-1.45,1.71,3.49,3.49,0,0,0-.28,2.18,5.27,5.27,0,0,0,2.77,3.52,12.75,12.75,0,0,0,4.56,1.26,42.11,42.11,0,0,0,4.74.33,75.4,75.4,0,0,0,9.32-.52c6.08-.68,12-1.66,17.63-1.72s11.14.72,15.71,3a18.5,18.5,0,0,1,5.84,4.37,13.39,13.39,0,0,1,3,6A16.16,16.16,0,0,1,464.47,357a18.93,18.93,0,0,1-5.93,6.33,22.34,22.34,0,0,1-4.9,2.5,15.14,15.14,0,0,1-1.84.55l.46-.17c.31-.09.76-.26,1.34-.48a23.09,23.09,0,0,0,4.83-2.57,18.94,18.94,0,0,0,5.79-6.3,16,16,0,0,0,1.63-11,13.23,13.23,0,0,0-3-5.82,18.1,18.1,0,0,0-5.73-4.24c-4.5-2.18-9.91-3-15.51-2.87s-11.48,1.05-17.59,1.74a72.3,72.3,0,0,1-9.38.54,43.17,43.17,0,0,1-4.8-.33,13.19,13.19,0,0,1-4.74-1.32,5.81,5.81,0,0,1-3-3.88,4.05,4.05,0,0,1,.32-2.5,5.21,5.21,0,0,1,1.61-1.9,7.2,7.2,0,0,1,4.6-1.36,8.91,8.91,0,0,1,4.49,1.5,8,8,0,0,1,2.95,3.58,7.88,7.88,0,0,1,.32,4.55,10,10,0,0,1-5.36,6.71,14.58,14.58,0,0,1-8.15,1.39,17.27,17.27,0,0,1-7.38-2.54,17.1,17.1,0,0,1-2.95-2.29,12,12,0,0,1-2.26-2.82,14.48,14.48,0,0,1-1-3.33q-.32-1.65-.51-3.24c-.52-4.25-.77-8.1-1.06-11.48s-.57-6.28-.9-8.64a36.24,36.24,0,0,0-1.09-5.37,12.93,12.93,0,0,0-.47-1.35A4.57,4.57,0,0,1,385.09,300.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.75,441s0-.14,0-.42,0-.68,0-1.2c0-1.08,0-2.65,0-4.69,0-4.11,0-10.11-.06-17.72,0-15.23-.07-36.93-.12-62.89l.23.23-80.65,0h0l.26-.26c0,32,0,61.82,0,86.92l-.22-.22,58.44.11,16.39.06,4.33,0,1.5,0-1.45,0L437,441l-16.33.06-58.59.11h-.23V441c0-25.1,0-55,0-86.92v-.26h.27l80.65,0H443V354c-.05,26-.09,47.77-.12,63,0,7.6,0,13.58-.06,17.67,0,2,0,3.58,0,4.65,0,.51,0,.9,0,1.18S442.75,441,442.75,441Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420,364.73a.41.41,0,0,1-.41.42.42.42,0,1,1,0-.83A.41.41,0,0,1,420,364.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.31,364.73a.41.41,0,0,1-.41.42.42.42,0,1,1,0-.83A.41.41,0,0,1,422.31,364.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.59,364.73a.41.41,0,0,1-.41.42.42.42,0,1,1,0-.83A.41.41,0,0,1,424.59,364.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.87,364.73a.42.42,0,1,1-.42-.41A.42.42,0,0,1,426.87,364.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.15,364.73a.42.42,0,0,1-.42.42.42.42,0,0,1,0-.83A.42.42,0,0,1,429.15,364.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.43,364.73a.42.42,0,0,1-.42.42.42.42,0,0,1,0-.83A.42.42,0,0,1,431.43,364.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.71,364.73a.42.42,0,0,1-.42.42.42.42,0,0,1,0-.83A.42.42,0,0,1,433.71,364.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 432.24,
    cy: 366.27,
    r: 0.41,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 429.91,
    cy: 366.27,
    r: 0.41,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428,366.27a.41.41,0,0,1-.41.41.41.41,0,0,1-.42-.41.42.42,0,0,1,.42-.42A.41.41,0,0,1,428,366.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 425.25,
    cy: 366.27,
    r: 0.41,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 422.91,
    cy: 366.27,
    r: 0.41,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421,366.27a.41.41,0,0,1-.42.41.41.41,0,0,1-.41-.41.41.41,0,0,1,.41-.42A.42.42,0,0,1,421,366.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420,368a.41.41,0,0,1-.41.41.41.41,0,0,1-.42-.41.42.42,0,0,1,.42-.42A.41.41,0,0,1,420,368Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.31,368a.41.41,0,0,1-.41.41.41.41,0,0,1-.42-.41.42.42,0,0,1,.42-.42A.41.41,0,0,1,422.31,368Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.59,368a.41.41,0,0,1-.41.41.41.41,0,0,1-.42-.41.42.42,0,0,1,.42-.42A.41.41,0,0,1,424.59,368Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.87,368a.42.42,0,0,1-.83,0,.42.42,0,1,1,.83,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.15,368a.41.41,0,0,1-.42.41.41.41,0,0,1-.41-.41.41.41,0,0,1,.41-.42A.42.42,0,0,1,429.15,368Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.43,368a.41.41,0,0,1-.42.41.41.41,0,0,1-.41-.41.41.41,0,0,1,.41-.42A.42.42,0,0,1,431.43,368Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.71,368a.41.41,0,0,1-.42.41.41.41,0,0,1-.41-.41.41.41,0,0,1,.41-.42A.42.42,0,0,1,433.71,368Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.66,369.53a.42.42,0,0,1-.42.42.41.41,0,0,1-.41-.42.41.41,0,0,1,.41-.41A.41.41,0,0,1,432.66,369.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.32,369.53a.41.41,0,0,1-.41.42.42.42,0,0,1-.42-.42.41.41,0,0,1,.42-.41A.41.41,0,0,1,430.32,369.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428,369.53a.41.41,0,0,1-.41.42.42.42,0,0,1-.42-.42.41.41,0,0,1,.42-.41A.41.41,0,0,1,428,369.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.66,369.53a.41.41,0,0,1-.41.42.42.42,0,0,1-.42-.42.41.41,0,0,1,.42-.41A.41.41,0,0,1,425.66,369.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.33,369.53a.42.42,0,1,1-.83,0,.42.42,0,0,1,.83,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421,369.53a.42.42,0,0,1-.42.42.41.41,0,0,1-.41-.42.41.41,0,0,1,.41-.41A.41.41,0,0,1,421,369.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420,371.26a.41.41,0,0,1-.41.42.42.42,0,0,1-.42-.42.41.41,0,0,1,.42-.41A.41.41,0,0,1,420,371.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.31,371.26a.41.41,0,0,1-.41.42.42.42,0,0,1-.42-.42.41.41,0,0,1,.42-.41A.41.41,0,0,1,422.31,371.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.59,371.26a.41.41,0,0,1-.41.42.42.42,0,0,1-.42-.42.41.41,0,0,1,.42-.41A.41.41,0,0,1,424.59,371.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.87,371.26a.42.42,0,1,1-.83,0,.42.42,0,0,1,.83,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.15,371.26a.42.42,0,0,1-.42.42.41.41,0,0,1-.41-.42.41.41,0,0,1,.41-.41A.41.41,0,0,1,429.15,371.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.43,371.26a.42.42,0,0,1-.42.42.41.41,0,0,1-.41-.42.41.41,0,0,1,.41-.41A.41.41,0,0,1,431.43,371.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.71,371.26a.42.42,0,0,1-.42.42.41.41,0,0,1-.41-.42.41.41,0,0,1,.41-.41A.41.41,0,0,1,433.71,371.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 432.24,
    cy: 372.8,
    r: 0.41,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 429.91,
    cy: 372.8,
    r: 0.41,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428,372.8a.41.41,0,0,1-.41.41.42.42,0,1,1,0-.83A.41.41,0,0,1,428,372.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 425.25,
    cy: 372.8,
    r: 0.41,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 422.91,
    cy: 372.8,
    r: 0.41,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421,372.8a.42.42,0,0,1-.42.41.42.42,0,0,1,0-.83A.42.42,0,0,1,421,372.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.5,271.29a5.23,5.23,0,0,1,1.62.29,9.09,9.09,0,0,1,3.94,2.57,17.15,17.15,0,0,1,3.49,6.6,65.44,65.44,0,0,1,2.19,9.67,122,122,0,0,1,.64,25.75,15.11,15.11,0,0,1-2.24,7.14,9.19,9.19,0,0,1-2.82,2.73,6.32,6.32,0,0,1-3.9.93,6.06,6.06,0,0,1-3.71-1.73,4.53,4.53,0,0,1-1.09-1.81,3.84,3.84,0,0,1,0-2.15,4.61,4.61,0,0,1,2.79-3.15,3.29,3.29,0,0,1,2.21,0,3.94,3.94,0,0,1,1.76,1.33,5.46,5.46,0,0,1,1,4.14,11.26,11.26,0,0,1-1.45,3.94,15.23,15.23,0,0,1-20.5,5.94,17.4,17.4,0,0,1-5.4-4.65A22.78,22.78,0,0,1,363.7,323a38.5,38.5,0,0,1-2.19-11.8c-.19-3.67,0-7-.35-9.88a16.89,16.89,0,0,0-.93-3.9,11.13,11.13,0,0,0-1.67-2.92,8.41,8.41,0,0,0-3.72-2.75,12,12,0,0,0-1.59-.38,5.31,5.31,0,0,1,1.63.29,8.18,8.18,0,0,1,3.83,2.71,11.08,11.08,0,0,1,1.75,3,16.88,16.88,0,0,1,1,4c.39,2.91.21,6.24.43,9.89a38.46,38.46,0,0,0,2.23,11.67,22.46,22.46,0,0,0,3.23,5.74,17,17,0,0,0,5.27,4.51,14.75,14.75,0,0,0,19.82-5.78,10.74,10.74,0,0,0,1.38-3.75,4.92,4.92,0,0,0-.87-3.76,3.56,3.56,0,0,0-1.53-1.16,2.76,2.76,0,0,0-1.86,0,4.1,4.1,0,0,0-2.46,2.79,3.59,3.59,0,0,0,1,3.47,5.53,5.53,0,0,0,3.39,1.58,5.8,5.8,0,0,0,3.59-.85,8.65,8.65,0,0,0,2.67-2.58,14.65,14.65,0,0,0,2.17-6.91,123.82,123.82,0,0,0-.52-25.65,67,67,0,0,0-2.11-9.63,17.1,17.1,0,0,0-3.36-6.55,9.12,9.12,0,0,0-3.82-2.61A12.17,12.17,0,0,0,388.5,271.29Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 347.43,
    y: 285.76,
    width: 33.22,
    height: 6.33,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97.52,
    y: 351.2,
    width: 43.33,
    height: 93.27,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.13,434.65s0-.14,0-.41,0-.66,0-1.16c0-1,0-2.53,0-4.46,0-3.9,0-9.55-.07-16.66,0-14.22-.07-34.24-.12-57.53l.25.24-36.25,0h0l.26-.26c0,31.16,0,59.46-.07,80.22l-.19-.19,26.47.1,7.24.05,1.89,0c.43,0,.66,0,.66,0l-.62,0-1.86,0-7.19,0-26.59.1h-.18v-.19c0-20.76,0-49.06-.08-80.22v-.26h36.77v.25c0,23.36-.09,43.44-.12,57.7,0,7.08,0,12.72-.07,16.6,0,1.91,0,3.39,0,4.41,0,.49,0,.86,0,1.13S137.13,434.65,137.13,434.65Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.89,361.22s0-.35,0-1,0-1.56-.06-2.7l.11.11c-5.61.09-17.63.15-31.52.15h0l.26-.26h0v1.86c0,.61,0,1.22,0,1.81l-.25-.26c8.81,0,16.65.06,22.32.11l6.71.07,1.83,0a3.3,3.3,0,0,1,.66,0,4.08,4.08,0,0,1-.59,0l-1.78,0-6.64.07c-5.66.06-13.59.11-22.51.11h-.26v-3.93h0l.27-.26h0c13.89,0,25.91.06,31.52.15H135v.11c0,1.17,0,2.09-.06,2.77A8.53,8.53,0,0,1,134.89,361.22Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.54,363.86c0,.14-.65.26-1.45.26s-1.46-.12-1.46-.26.65-.26,1.46-.26S106.54,363.71,106.54,363.86Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.05,368.67c0,.14-6.71.26-15,.26s-15-.12-15-.26,6.7-.26,15-.26S134.05,368.53,134.05,368.67Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.18,374.48c0,.15-6.6.26-14.73.26s-14.73-.11-14.73-.26,6.59-.26,14.73-.26S134.18,374.34,134.18,374.48Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 119.06,
    cy: 388.07,
    r: 2.38,
    style: {
      fill: "#1A1C20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.34,388a10.14,10.14,0,0,1-3.19.26A10.05,10.05,0,0,1,106,388a9.72,9.72,0,0,1,3.18-.26A9.81,9.81,0,0,1,112.34,388Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.7,387.34a8.91,8.91,0,0,1-3,.26,8.88,8.88,0,0,1-3-.26,9.18,9.18,0,0,1,3-.26A9.22,9.22,0,0,1,131.7,387.34Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99,398a9.25,9.25,0,0,1-1.62-.3,14.19,14.19,0,0,1-4.29-2,18.38,18.38,0,0,1-5.17-5.39,31.16,31.16,0,0,1-3.77-9.16A37.4,37.4,0,0,1,83,369.22a24.5,24.5,0,0,1,4.55-12.94,20.42,20.42,0,0,1,5.43-5.16,18.9,18.9,0,0,1,3.49-1.73,19.39,19.39,0,0,1,3.86-.92c2.64-.37,5.34-.32,8-.48a19.92,19.92,0,0,0,7.91-1.82,8.88,8.88,0,0,0,4.92-6,8.43,8.43,0,0,0-8.42-10.3,6,6,0,0,0-3.34,1.24,3.62,3.62,0,0,0-1.4,3,4.85,4.85,0,0,0,4.46,4.31,7.35,7.35,0,0,0,5.72-2.57A13.76,13.76,0,0,0,121,330.4a47,47,0,0,0,1.15-5.61,92.48,92.48,0,0,0,.53-17.31c-.1-2-.18-3.61-.24-4.71q0-.78-.06-1.23a2.21,2.21,0,0,1,0-.42,2.29,2.29,0,0,1,.06.42c0,.3.06.7.11,1.22.08,1.08.21,2.66.33,4.71a88.2,88.2,0,0,1-.37,17.37,46.56,46.56,0,0,1-1.13,5.67,14.19,14.19,0,0,1-2.83,5.61,7.76,7.76,0,0,1-6.07,2.73,5.3,5.3,0,0,1-4.91-4.74,4.13,4.13,0,0,1,1.57-3.42,6.38,6.38,0,0,1,3.61-1.35A9,9,0,0,1,119.84,344a10.3,10.3,0,0,1-3.35,2.61,20.41,20.41,0,0,1-8.12,1.88c-2.73.16-5.42.11-8,.46a19.44,19.44,0,0,0-3.76.89,17.84,17.84,0,0,0-3.39,1.68,20.12,20.12,0,0,0-5.32,5,24.16,24.16,0,0,0-4.5,12.68,37.41,37.41,0,0,0,1.12,11.83,31.49,31.49,0,0,0,3.66,9.09,18.34,18.34,0,0,0,5,5.38,14.78,14.78,0,0,0,4.21,2.06c.51.15.91.24,1.18.3A1.82,1.82,0,0,1,99,398Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.25,
    y: 206.51,
    width: 102.6,
    height: 70.46,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.62,
    y: 267.36,
    width: 13.97,
    height: 26.58,
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Desk--inject-15"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "94.46 292.92 94.46 302.48 147.4 302.48 147.4 444.94 152.27 444.94 152.27 302.48 373.36 303.57 373.36 444.94 378.14 444.94 378.14 303.31 412.26 303.58 412.26 292.09 94.46 292.92",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "128.34 300.62 149.21 315.65 147.4 317.39 126.35 301.54 128.34 300.62",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "397.81 302.02 373.59 319.27 375.41 321.01 399.8 302.94 397.81 302.02",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.44,
    y: 289.39,
    width: 54.72,
    height: 4.03,
    style: {
      fill: "#263238"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkillImg);
export default __webpack_public_path__ + "static/media/skillImg.92a4ec446bc7607de0542eadae402108.svg";
export { ForwardRef as ReactComponent };